import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Popup from "reactjs-popup";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import {
  Camera,
  FileText,
  Eye,
  EyeOff,
  Upload,
  Trash,
  Plus,
  X,
} from "lucide-react";
import { MdOutlineCancel } from "react-icons/md";
import { ChevronDown } from "lucide-react";

import languageLogo from "../assets/Icons/language-icon-matrimony.png";

const RegisterForm = () => {
  const [formData, setFormData] = useState({
    full_name: "",
    matrimony_id: "",
    age: "",
    gender: "",
    date_of_birth: "",
    height: "",
    weight: "",
    email: "",
    occupation: "",
    annual_income: "",
    phone_number: "",
    password: "",
    photo: null,
    photos: [],
    mother_tongue: "",
    profile_created_by: "",
    address: "",
    work_type: "",
    company: "",
    education: "",
    work_location: "",
    work_country: "",
    mother_name: "",
    father_name: "",
    sibling_count: "",
    //siblings: [],
    elder_brother: "",
    younger_brother: "",
    elder_sister: "",
    younger_sister: "",
    native: "",
    mother_occupation: "",
    father_occupation: "",
    religion: "",
    caste: "",
    sub_caste: "",
    nakshatra: "",
    birth_time: "",
    birth_place: "",
    rashi: "",
    ascendent: "",
    horoscope_documents: [],
    blood_group: "",
    quarter: "",
    dhosham: "",
    other_dhosham: "",
    preferred_age_min: "",
    preferred_age_max: "",
    preferred_height_min: "",
    preferred_height_max: "",
    preferred_religion: "",
    preferred_caste: "",
    preferred_sub_caste: "",
    preferred_nakshatra: "",
    preferred_rashi: "",
    preferred_location: "",
    preferred_work_status: "",
    user_type: "user",
    marital_status: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [photoPreview, setPhotoPreview] = useState(null);
  const [previewPhoto, setPreviewPhoto] = useState(null);
  const [photosPreview, setPhotosPreview] = useState([]);
  const [horoscopePreviews, setHoroscopePreviews] = useState([]);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [filePreviews, setFilePreviews] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [photos, setPhotos] = useState([]);
  const [language, setLanguage] = useState("english");
  const [step, setStep] = useState(1);
  const [toast, setToast] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false); // To track if the code is sent
  const [selectedCaste, setSelectedCaste] = useState("");
  const navigate = useNavigate();
  const [Name, setName] = useState("");
  const [files, setFiles] = useState([]);
  const [error, setError] = useState("");
  const [lastMatrimonyId, setLastMatrimonyId] = useState(null);
  const [lockedFields, setLockedFields] = useState({
    elder_brother: false,
    younger_brother: false,
    elder_sister: false,
    younger_sister: false,
  });
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);

  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => setToast(null), 3000);
      return () => clearTimeout(timer);
    }
  }, [toast]);

  const handleProfilePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, photo: file });
      setPhotoPreview(URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    const fetchLastMatrimonyId = async () => {
      try {
        const response = await fetch(
          "https://backend.newbrindha.com/matrimony/lastMatrimonyId",
        );
        if (!response.ok) {
          throw new Error("Failed to fetch last Matrimony ID");
        }
        const data = await response.json();
        setLastMatrimonyId(data.last_matrimony_id); 
      } catch (error) {
        console.error("Error fetching last Matrimony ID:", error);
      }
    };

    fetchLastMatrimonyId();
  }, []);

  useEffect(() => {
    if (lastMatrimonyId) {
      // const numericPart = parseInt(lastMatrimonyId.replace(/\D/g, ""), 10) || 0; 
      // const newNumericId = numericPart + 1; 
      // const newMatrimonyId = `NBS${newNumericId}`; 

      const idString = String(lastMatrimonyId);
    const numericPart = parseInt(idString.replace(/\D/g, ""), 10) || 0; 
    const newNumericId = numericPart + 1; 
    const newMatrimonyId = `NBS${newNumericId}`;

      setFormData((prevData) => ({
        ...prevData,
        matrimony_id: newMatrimonyId,
      }));

      const updateLastMatrimonyId = async () => {
        try {
          const response = await fetch(
            "https://backend.newbrindha.com/matrimony/incrementMatrimonyId",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ last_matrimony_id: newMatrimonyId }), 
            },
          );

          if (!response.ok) {
            throw new Error("Failed to update last Matrimony ID");
          }
          console.log("Last Matrimony ID updated successfully");
        } catch (error) {
          console.error("Error updating last Matrimony ID:", error);
        }
      };

      updateLastMatrimonyId();
    }
  }, [lastMatrimonyId]);

  const handlePhotoUpload = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const updatedPhotos = [...formData.photos];
      updatedPhotos[index] = file;
      setFormData({ ...formData, photos: updatedPhotos });

      const updatedPreviews = [...photosPreview];
      updatedPreviews[index] = URL.createObjectURL(file);
      setPhotosPreview(updatedPreviews);
    }
  };

  const addPhotoField = () => {
    if (formData.photos.length < 5) {
      setFormData({ ...formData, photos: [...formData.photos, null] });
      setPhotosPreview([...photosPreview, null]);
    } else {
      showToast(
        language === "english"
          ? "You can only upload up to 5 photos."
          : "நீங்கள் 5 படங்கள் மட்டுமே பதிவேற்ற முடியும்.",
        "error",
      );
    }
  };

  const removePhoto = (index) => {
    const updatedPhotos = formData.photos.filter((_, i) => i !== index);
    const updatedPreviews = photosPreview.filter((_, i) => i !== index);
    setFormData({ ...formData, photos: updatedPhotos });
    setPhotosPreview(updatedPreviews);
  };

  const handleHoroscopeUpload = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type === "application/pdf") {
        const updatedDocuments = [...formData.horoscope_documents];
        updatedDocuments[index] = file;
        setFormData({ ...formData, horoscope_documents: updatedDocuments });

        const updatedPreviews = [...horoscopePreviews];
        updatedPreviews[index] = file.name;
        setHoroscopePreviews(updatedPreviews);
      } else {
        showToast(
          language === "english"
            ? "Only PDF files are allowed."
            : "PDF கோப்புகள் மட்டுமே அனுமதிக்கப்படுகின்றன.",
          "error",
        );
      }
    }
  };

  const addHoroscopeField = () => {
    if (formData.horoscope_documents.length < 5) {
      setFormData({
        ...formData,
        horoscope_documents: [...formData.horoscope_documents, null],
      });
      setHoroscopePreviews([...horoscopePreviews, null]);
    } else {
      showToast(
        language === "english"
          ? "You can only upload up to 5 horoscope documents."
          : "நீங்கள் 5 ஜோதிட ஆவணங்கள் மட்டுமே பதிவேற்ற முடியும்.",
        "error",
      );
    }
  };

  const toggleLanguageDropdown = () => {
    setShowLanguageDropdown((prev) => !prev);
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    setShowLanguageDropdown(false);
  };

  const removeHoroscope = (index) => {
    const updatedDocuments = formData.horoscope_documents.filter(
      (_, i) => i !== index,
    );
    const updatedPreviews = horoscopePreviews.filter((_, i) => i !== index);
    setFormData({ ...formData, horoscope_documents: updatedDocuments });
    setHoroscopePreviews(updatedPreviews);
  };

  const renderPhotoFields = () => {
    return formData.photos.map((_, index) => (
      <div key={index} className="flex items-center space-x-2 py-2">
        <input
          type="file"
          accept="image/*"
          onChange={(e) => handlePhotoUpload(e, index)}
          className="hidden"
          id={`photo-${index}`}
          title="click to add photo"
        />
        <label
          htmlFor={`photo-${index}`}
          className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg cursor-pointer hover:bg-gray-200"
        >
          {photosPreview[index] ? (
            <img
              src={photosPreview[index]}
              alt={`Preview ${index}`}
              className="w-10 h-10 object-cover rounded-lg cursor-pointer"
              onClick={() => setPreviewFile(formData.photos[index])}
            />
          ) : (
            <Plus className="w-5 h-5 text-gray-600" />
          )}
        </label>
        {photosPreview[index] && (
          <div className="relative">
            <button
              onClick={() => removePhoto(index)}
              className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
            >
              <Trash className="w-3 h-3" />
            </button>
          </div>
        )}
      </div>
    ));
  };

  const renderHoroscopeFields = () => {
    return formData.horoscope_documents.map((_, index) => (
      <div
        key={index}
        className="flex flex-col items-start px-3 sm:px-4 md:px-6 py-2.5 sm:py-4 md:py-6"
      >
        <div className="flex items-center space-x-2">
          <input
            type="file"
            accept="application/pdf"
            onChange={(e) => handleHoroscopeUpload(e, index)}
            className="hidden"
            id={`horoscope-${index}`}
          />
          <label
            htmlFor={`horoscope-${index}`}
            className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg cursor-pointer hover:bg-gray-200"
          >
            <FileText className="w-5 h-5 text-gray-600 text-wrap" />
          </label>
          {horoscopePreviews[index] && (
            <div className="relative">
              <button
                onClick={() => removeHoroscope(index)}
                className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
              >
                <Trash className="w-3 h-3" />
              </button>
            </div>
          )}
        </div>
        {horoscopePreviews[index] && (
          <a
            href={URL.createObjectURL(formData.horoscope_documents[index])}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-gray-600 hover:text-[#e67e22]"
          >
            📄 {horoscopePreviews[index]}
          </a>
        )}
      </div>
    ));
  };

  const funnyMessages = {
    english: [
      "👀 Swipe right on your future! Let’s do this!",
      "💍 One step closer to 'I do'! Keep going!",
      "🌟 Your perfect match is just a few clicks away!",
      "💬 Cupid’s working overtime for you! Let’s go!",
      "🚀 Ready to find your soulmate? Let’s go!",
    ],
    tamil: [
      "👀 உங்கள் எதிர்காலத்தை தேடுங்கள்! இதை செய்யலாம்!",
      "💍 'நான் செய்கிறேன்' என்று சொல்வதற்கு ஒரு படி முன்னேறுங்கள்!",
      "🌟 உங்கள் சரியான பொருத்தம் சில கிளிக்குகள் தூரத்தில் உள்ளது!",
      "💬 குபிட் உங்களுக்காக கூடுதல் நேரம் வேலை செய்கிறார்! போகலாம்!",
      "🚀 உங்கள் ஆத்ம தோழரைக் கண்டுபிடிக்க தயாரா? போகலாம்!",
    ],
  };

  const [shownMessages, setShownMessages] = useState([]);

  const showToast = (message, type = "info") => {
    console.log("Current language:", language);

    const motivationalMessages = {
      success:
        language === "english"
          ? "🎉 Registration successful! Redirecting..."
          : "🎉 பதிவு வெற்றிகரமாக! திருப்பி வழிநடத்தப்படுகிறது...",
      error:
        language === "english"
          ? "❌ Registration failed. Please try again."
          : "❌ பதிவு தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.",
    };

    setToast({
      message: message || motivationalMessages[type],
      type,
    });

    setTimeout(() => setToast(null), 3000); // Auto-hide after 3 seconds
  };

  const getRandomFunnyMessage = () => {
    const availableMessages = funnyMessages[language].filter(
      (msg) => !shownMessages.includes(msg),
    );

    if (availableMessages.length === 0) {
      setShownMessages([]);
      return funnyMessages[language][
        Math.floor(Math.random() * funnyMessages[language].length)
      ];
    }

    const randomMessage =
      availableMessages[Math.floor(Math.random() * availableMessages.length)];
    setShownMessages((prev) => [...prev, randomMessage]);
    return randomMessage;
  };

  //   const calculateProgress = (formData) => {
  //     const totalFields = Object.keys(formData).length; // Total fields in the form
  //     const filledFields = Object.values(formData).filter((value) => {
  //       // Check if the field is filled (not empty or null)
  //       if (Array.isArray(value)) {
  //         return value.length > 0; // For arrays (e.g., photos, horoscope_documents)
  //       }
  //       return value !== null && value !== ""; // For other fields
  //     }).length;

  //     // Calculate the percentage of filled fields
  //     return Math.round((filledFields / totalFields) * 100);
  //   };

  // const [progress, setProgress] = useState(() => calculateProgress(formData));

  //   useEffect(() => {
  //     setProgress(calculateProgress(formData));
  //   }, [formData]);

  const renderSiblingFields = () => {
    const siblingCount = parseInt(formData.sibling_count, 10) || 0;
    const siblingFields = [
      "elder_brother",
      "younger_brother",
      "elder_sister",
      "younger_sister",
    ];

    return siblingFields.map((field) => (
      <div key={field}>
        <label className="text-sm text-gray-600">{languageData?.[field]}</label>
        <input
          type="text"
          value={formData[field]}
          onChange={(e) => handleInputChange(field, e.target.value)}
          onBlur={() => handleBlur(field)}
          className={`w-full px-3 py-2 border rounded-lg shadow-sm 
            ${
              touched[field] && errors[field]
                ? "border-red-500"
                : "border-gray-300"
            }
            focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
            transition-all duration-300 hover:border-[#f39c12]`}
          placeholder={languageData?.[field]}
          disabled={lockedFields[field] || siblingCount <= 0}
        />
        {touched[field] && errors[field] && (
          <p className="text-red-500 text-sm">{errors[field]}</p>
        )}
      </div>
    ));
  };

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const updatedPhotos = [...photos, ...selectedFiles].slice(0, 5); // Max 5 photos
    setPhotos(updatedPhotos);

    // Remove error when at least one photo is uploaded
    setErrors((prev) => ({ ...prev, photos: "" }));
    setTouched((prev) => ({ ...prev, photos: false }));
  };

  const handleRashiChange = (rashi, isChecked) => {
    setFormData((prevData) => {
      let updatedRashi = [...prevData.rashi];

      // If checkbox is checked, add the Rashi, otherwise remove it
      if (isChecked) {
        updatedRashi.push(rashi); // Add the selected Rashi
      } else {
        updatedRashi = updatedRashi.filter((item) => item !== rashi); // Remove the deselected Rashi
      }

      // Return updated form data with the new 'rashi' selection
      return { ...prevData, rashi: updatedRashi };
    });
  };

  const handleInputChange = (name, value, isChecked = null) => {
    setFormData((prevData) => {
      // Initialize errors if they don't exist
      const errors = prevData.errors || {};

      // Create a copy of the form data
      let updatedData = { ...prevData };

      if (name === "password") {
        const passwordRegex =
          /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;

        const errorMessages = {
          english:
            "Password must be at least 8 characters long and include letters, numbers, and special characters.",
          tamil:
            "கடவுச்சொல் குறைந்தது 8 எழுத்துகள் கொண்டதாக இருக்க வேண்டும் மற்றும் எழுத்துகள், எண்கள், சிறப்பு எழுத்துக்களை கொண்டிருக்க வேண்டும்.",
        };

        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: passwordRegex.test(value) ? null : errorMessages[language],
        }));
      }

      // Handle Nakshatra input
      if (name === "nakshatra") {
        if (!Array.isArray(updatedData.nakshatra)) {
          updatedData.nakshatra = [];
        }

        if (isChecked !== null) {
          // Handle checkbox behavior
          if (isChecked) {
            updatedData.nakshatra = [...updatedData.nakshatra, value];
          } else {
            updatedData.nakshatra = updatedData.nakshatra.filter(
              (item) => item !== value,
            );
          }
        } else {
          // Handle dropdown behavior
          updatedData.nakshatra = value;
        }

        // Calculate Rashi for Nakshatra change
        const rashiValue =
          nakshatraRasiMap[language]?.[value]?.[updatedData.quarter - 1];
        updatedData.rashi = rashiValue || "";
      }

      // Handle quarter  change
      if (name === "quarter ") {
        updatedData.quarter = value;
        // Calculate Rashi for quarter  change
        const rashiValue =
          nakshatraRasiMap[language]?.[updatedData.nakshatra]?.[value - 1];
        updatedData.rashi = rashiValue || "";
      }

      // Handle height range validation
      if (name === "preferred_height_min") {
        if (value < 50) {
          errors.preferred_height_min =
            language === "tamil"
              ? "குறைந்தபட்ச உயரம் 50 க்கும் குறைவாக இருக்கக்கூடாது."
              : "Minimum height cannot be less than 50.";
        } else {
          delete errors.preferred_height_min;
        }
      }

      if (name === "preferred_height_max") {
        if (value > 250) {
          errors.preferred_height_max =
            language === "tamil"
              ? "அதிகபட்ச உயரம் 250 ஐ விட அதிகமாக இருக்கக்கூடாது."
              : "Maximum height cannot be greater than 250.";
        } else {
          delete errors.preferred_height_max;
        }
      }

      // Handle age range validation
      if (name === "preferred_age_min") {
        if (value <= 21) {
          errors.preferred_age_min = "Min age must be at least 21";
        } else if (
          value > prevData.preferred_age_max &&
          prevData.preferred_age_max
        ) {
          errors.preferred_age_min = "Min age cannot be greater than Max age";
        } else {
          delete errors.preferred_age_min;
        }
      }

      if (name === "preferred_age_max") {
        if (value >= 100) {
          errors.preferred_age_max = "Max age must be at most 100";
        } else if (
          value < prevData.preferred_age_min &&
          prevData.preferred_age_min
        ) {
          errors.preferred_age_max = "Max age cannot be less than Min age";
        } else {
          delete errors.preferred_age_max;
        }
      }

      // Handle sibling count
      if (name === "sibling_count") {
        const count = parseInt(value, 10);
        if (!isNaN(count) && count >= 0) {
          updatedData.siblings = new Array(count)
            .fill("")
            .map((_, index) => prevData.siblings?.[index] || "");
        }
      }

      // Handle date of birth and age calculation
      if (name === "date_of_birth") {
        const birthDate = new Date(value);
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (
          monthDiff < 0 ||
          (monthDiff === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }

        updatedData.age = age >= 0 ? age : "";
      }

      // Handle religion input (multiple options)
      if (name === "religion") {
        if (!Array.isArray(updatedData.religion)) {
          updatedData.religion = []; // Ensure it's an array
        }

        if (isChecked) {
          // Add to array (if not already added)
          if (!updatedData.religion.includes(value)) {
            updatedData.religion = [...updatedData.religion, value];
          }
        } else {
          // Remove from array
          updatedData.religion = updatedData.religion.filter(
            (item) => item !== value,
          );
        }
      }

      // Handle general checkboxes for multiple values
      if (
        name !== "nakshatra" &&
        name !== "religion" &&
        Array.isArray(updatedData[name])
      ) {
        if (isChecked) {
          updatedData[name] = [...updatedData[name], value];
        } else {
          updatedData[name] = updatedData[name].filter(
            (item) => item !== value,
          );
        }
      }

      // Handle all other fields
      if (!["nakshatra", "quarter ", "religion"].includes(name)) {
        updatedData[name] = value;
      }

      // Update errors in the form data
      updatedData.errors = errors;

      return updatedData;
    });

    // Mark the field as touched
    setTouched((prev) => ({ ...prev, [name]: true }));

    // Validate the field if validation function exists
    if (typeof validateField === "function") {
      validateField(name, value);
    }
  };

  useEffect(() => {
    const storedFullName = localStorage.getItem("fullName");
    const storedPhoneNumber = localStorage.getItem("mobileNumber");

    setFormData((prev) => ({
      ...prev,
      full_name: storedFullName || "",
      phone_number: storedPhoneNumber || "",
    }));

    console.log("Retrieved from localStorage:", {
      storedFullName,
      storedPhoneNumber,
    });
  }, []);

  const validateField = (field, value) => {
    let newErrors = { ...errors };

    if (!value) {
      // newErrors[field] = language === 'english' ? 'This field is required' : 'இந்த புலம் தேவை';
    } else if (field === "email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      newErrors[field] =
        language === "english"
          ? "Invalid email format"
          : "தவறான மின்னஞ்சல் வடிவம்";
    } else if (
      field === "password" &&
      /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{8,}$/.test(value)
    ) {
      newErrors[field] =
        language === "english"
          ? "Password must be at least 8 characters with letters and numbers"
          : "கடவுச்சொல் குறைந்தது 8 எழுத்துகள் மற்றும் எண்கள் இருக்க வேண்டும்";
    } else if (
      field === "blood_group" &&
      !["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"].includes(value)
    ) {
      newErrors[field] =
        language === "english" ? "Invalid blood group" : "தவறான இரத்த வகை";
    } else if (field === "age" && (isNaN(value) || value < 18 || value > 100)) {
      newErrors[field] =
        language === "english"
          ? "Age must be between 18 and 100"
          : "வயது 18 மற்றும் 100 க்கு இடையில் இருக்க வேண்டும்";
    } else if (field === "date_of_birth") {
      const today = new Date();
      const birthDate = new Date(value);
      const age = today.getFullYear() - birthDate.getFullYear();

      if (
        age < 18 ||
        (age === 18 && today.getMonth() < birthDate.getMonth()) ||
        (age === 18 &&
          today.getMonth() === birthDate.getMonth() &&
          today.getDate() < birthDate.getDate())
      ) {
        newErrors[field] =
          language === "english"
            ? "You must be at least 18 years old."
            : "நீங்கள் குறைந்தது 18 வயது இருக்க வேண்டும்.";
      }
    } else if (field === "phone_number" && !/^\d{10}$/.test(value)) {
      newErrors[field] =
        language === "english"
          ? "Invalid phone number (10 digits required)"
          : "தவறான தொலைபேசி எண் (10 இலக்கங்கள் தேவை)";
    } else if (field === "sibling_count" && (isNaN(value) || value < 0)) {
      newErrors[field] =
        language === "english"
          ? "Sibling count cannot be less than 0"
          : "சகோதரர்களின் எண்ணிக்கை 0 க்கும் குறைவாக இருக்க முடியாது";
    } else {
      delete newErrors[field];
    }

    setErrors(newErrors);
  };

  const validateForm = () => {
    let isValid = true;
    let newErrors = {};
    let newTouched = {};

    // Check required fields
    if (!formData.photo) {
      newErrors.photo =
        translations[language].photoRequired || "Photo is required";
      newTouched.photo = true;
      isValid = false;
    }
    if (!formData.matrimony_id) {
      newErrors.matrimony_id =
        translations[language].matrimonyIdRequired ||
        "Matrimony ID is required";
      newTouched.matrimony_id = true;
      isValid = false;
    }
    if (!formData.age) {
      newErrors.age = translations[language].ageRequired || "Age is required";
      newTouched.age = true;
      isValid = false;
    }
    if (!formData.gender) {
      newErrors.gender =
        translations[language].genderRequired || "Gender is required";
      newTouched.gender = true;
      isValid = false;
    }
    if (!formData.date_of_birth) {
      newErrors.date_of_birth =
        translations[language].dateOfBirthRequired ||
        "Date of birth is required";
      newTouched.date_of_birth = true;
      isValid = false;
    }
    if (!formData.password) {
      newErrors.password =
        translations[language].passwordRequired || "Password is required";
      newTouched.password = true;
      isValid = false;
    }

    // Age validation based on date_of_birth
    if (formData.date_of_birth) {
      const today = new Date();
      const birthDate = new Date(formData.date_of_birth);
      const age = today.getFullYear() - birthDate.getFullYear();

      if (
        age < 18 ||
        (age === 18 && today.getMonth() < birthDate.getMonth()) ||
        (age === 18 &&
          today.getMonth() === birthDate.getMonth() &&
          today.getDate() < birthDate.getDate())
      ) {
        newErrors.date_of_birth =
          language === "english"
            ? "You must be at least 18 years old."
            : "நீங்கள் குறைந்தது 18 வயது இருக்க வேண்டும்.";
        newTouched.date_of_birth = true;
        isValid = false;
      }
    }

    // Update state for errors and touched
    setErrors(newErrors);
    setTouched(newTouched);

    // Return the form validity status
    return isValid;
  };

  // Handle Next Step Navigation
  const handleNextStep = () => {
    let newErrors = {};
    let newTouched = { ...touched }; // Track touched fields

    // Required field validation (excluding email)
    const isTamil = language === "tamil"; // Check the selected language

    /** ====================== STEP 1 VALIDATION ====================== */
    if (step === 1) {
      if (!formData.photo) {
        newErrors.photo = isTamil
          ? "சுயவிவர படம் தேவையானது."
          : "Profile photo is required.";
        newTouched.photo = true;
      }
      if (!formData.date_of_birth) {
        newErrors.date_of_birth = isTamil
          ? "பிறந்த தேதி தேவையானது."
          : "Date of birth is required.";
        newTouched.date_of_birth = true;
      } else {
        // Calculate Age
        const today = new Date();
        const birthDate = new Date(formData.date_of_birth);
        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDiff = today.getMonth() - birthDate.getMonth();

        if (
          monthDiff < 0 ||
          (monthDiff === 0 && today.getDate() < birthDate.getDate())
        ) {
          age--;
        }

        // Check minimum age
        if (age < 18) {
          newErrors.date_of_birth = isTamil
            ? "நீங்கள் குறைந்தது 18 வயது இருக்க வேண்டும்."
            : "You must be at least 18 years old.";
          newTouched.date_of_birth = true;
        }
      }

      if (!formData.gender) {
        newErrors.gender = isTamil
          ? "பாலினம் தேவையானது."
          : "Gender is required.";
        newTouched.gender = true;
      }
      if (!formData.password) {
        newErrors.password = isTamil
          ? "கடவுச்சொல் தேவையானது."
          : "Password is required.";
        newTouched.password = true;
      }
      if (!formData.email) {
        newErrors.email = isTamil ? "மின்னஞ்சல் தேவை." : "Email is required.";
        newTouched.email = true;
      }
    }

    // If errors exist, update the state and stop proceeding
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setTouched(newTouched); // Ensure fields are marked as touched
      return; // Prevent moving to the next step
    }

    // Move to the next step if no errors
    setErrors({}); // Clear previous errors
    setTouched({}); // Reset touched fields if needed
    setStep(step + 1); // Proceed to next step
  };

  const rashiOptions = [
    { value: "Aries", label: { en: "Aries", ta: "மேஷம்" } },
    { value: "Taurus", label: { en: "Taurus", ta: "ரிஷபம்" } },
    { value: "Gemini", label: { en: "Gemini", ta: "மிதுனம்" } },
    { value: "Cancer", label: { en: "Cancer", ta: "கடகம்" } },
    { value: "Leo", label: { en: "Leo", ta: "சிம்மம்" } },
    { value: "Virgo", label: { en: "Virgo", ta: "கன்னி" } },
    { value: "Libra", label: { en: "Libra", ta: "துலாம்" } },
    { value: "Vrischika", label: { en: "Scorpio", ta: "விருச்சிகம்" } },
    { value: "Sagittarius", label: { en: "Sagittarius", ta: "தனுசு" } },
    { value: "Capricorn", label: { en: "Capricorn", ta: "மகரம்" } },
    { value: "Aquarius", label: { en: "Aquarius", ta: "கும்பம்" } },
    { value: "Pisces", label: { en: "Pisces", ta: "மீனம்" } },
  ];

  const casteOptions = [
    {
      value: "manai-chettiar",
      tamil: "மணை செட்டியார்",
      english: "Manai Chettiar",
    },
    { value: "adaviyar", tamil: "அடவியார்", english: "Adaviyar" },
    { value: "adi-dravida", tamil: "ஆடி திராவிட", english: "Adi Dravida" },
    { value: "agamudayar", tamil: "அகமுடாயர்", english: "Agamudayar" },
    { value: "ambalkarar", tamil: "அம்பல்கரர்", english: "Ambalkarar" },
    {
      value: "arunthathiyar",
      tamil: "அருந்தாதியார்",
      english: "Arunthathiyar",
    },
    { value: "arya-vysya", tamil: "ஆர்ய விஸ்யா", english: "Arya Vysya" },
    { value: "baduga", tamil: "பதுக", english: "Baduga" },
    { value: "balija-naidu", tamil: "பலிஜ நாயுடு", english: "Balija Naidu" },
    { value: "brahmin", tamil: "பிராமன்", english: "Brahmin" },
    {
      value: "brahmin-gurukkal",
      tamil: "பிராமன்-குருக்கல்",
      english: "Brahmin Gurukkal",
    },
    {
      value: "brahmin-iyengar",
      tamil: "பிராமன்-ஐயங்கார்",
      english: "Brahmin Iyengar",
    },
    { value: "brahmin-iyer", tamil: "பிராமன்-ஐயர்", english: "Brahmin Iyer" },
    {
      value: "chadata-sri-vaishnava",
      tamil: "சடடா ஸ்ரீ வைஷ்ணவ",
      english: "Chadata Sri Vaishnava",
    },
    { value: "chettiar", tamil: "செட்டியார்", english: "Chettiar" },
    { value: "desigar", tamil: "தெசிகர்", english: "Desigar" },
    {
      value: "devandra-kula-vellalar",
      tamil: "தேவாண்டிர குல வேள்ளாளர்",
      english: "Devandra Kula Vellalar",
    },
    {
      value: "devanga-chettiar",
      tamil: "தேவங்க செட்டியார்",
      english: "Devanga Chettiar",
    },
    { value: "devar", tamil: "தேவர்", english: "Devar" },
    { value: "gavura-naidu", tamil: "கவுர நாயுடு", english: "Gavura Naidu" },
    { value: "gounder", tamil: "கவுன்டர்", english: "Gounder" },
    { value: "intercaste", tamil: "இண்டர்கேஸ்ட்", english: "Intercaste" },
    { value: "jetty", tamil: "ஜெட்டி", english: "Jetty" },
    { value: "kalar", tamil: "கலார்", english: "Kalar" },
    {
      value: "kammavar-naidu",
      tamil: "கம்மவர் நாயுடு",
      english: "Kammavar Naidu",
    },
    {
      value: "kannada-naicker",
      tamil: "கன்னட நாயக்கர்",
      english: "Kannada Naicker",
    },
    { value: "karuneegar", tamil: "கருணீகர", english: "Karuneegar" },
    {
      value: "kashatriya-raja",
      tamil: "கஷ்டிரிய ராஜா",
      english: "Kashatriya Raja",
    },
    { value: "keralites", tamil: "கேரளைட்டீஸ்", english: "Keralites" },
    {
      value: "kongu-vellala-gounder",
      tamil: "கோங்கு வேள்ளள கவுன்டர்",
      english: "Kongu Vellala Gounder",
    },
    { value: "kulalar", tamil: "குலளர்", english: "Kulalar" },
    { value: "kuravar", tamil: "குரவர", english: "Kuravar" },
    { value: "kurumbar", tamil: "குரும்பார்", english: "Kurumbar" },
    { value: "lohana", tamil: "லோஹனா", english: "Lohana" },
    { value: "madiwaldru", tamil: "மடிய்வால்த்ரு", english: "Madiwaldru" },
    { value: "maravar", tamil: "மரவர்", english: "Maravar" },
    { value: "maruthuvar", tamil: "மருத்துவர்", english: "Maruthuvar" },
    { value: "meenavar", tamil: "மீனவர்", english: "Meenavar" },
    { value: "mudaliyar", tamil: "முதலியார்", english: "Mudaliyar" },
    { value: "mukkulathor", tamil: "முக்குலத்தோர்", english: "Mukkulathor" },
    { value: "mutharaiyar", tamil: "முதறையார்", english: "Mutharaiyar" },
    { value: "muthuraja", tamil: "முதுராஜா", english: "Muthuraja" },
    { value: "nadar", tamil: "நாதர்", english: "Nadar" },
    { value: "naicker", tamil: "நாயக்கர்", english: "Naicker" },
    { value: "naidu", tamil: "நாயுடு", english: "Naidu" },
    { value: "nainar", tamil: "நைனர்", english: "Nainar" },
    {
      value: "namakkar-naidu",
      tamil: "நமக்கர் நாயுடு (SC)",
      english: "Namakkar Naidu (SC)",
    },
    { value: "namdev", tamil: "நாம்தேவ்", english: "Namdev" },
    { value: "pandaram", tamil: "பண்டாரம்", english: "Pandaram" },
    { value: "pannaiyar", tamil: "பண்ணையார்", english: "Pannaiyar" },
    { value: "parkava-kulam", tamil: "பார்கவ குலம்", english: "Parkava Kulam" },
    { value: "pattariyar", tamil: "பட்டாரியார்", english: "Pattariyar" },
    { value: "pillai", tamil: "பிள்ளை", english: "Pillai" },
    { value: "reddy", tamil: "ரெட்டி", english: "Reddy" },
    { value: "saiva-pillai", tamil: "சைவ பிள்ளை", english: "Saiva Pillai" },
    { value: "saliyar", tamil: "சாலியார்", english: "Saliyar" },
    { value: "sc", tamil: "SC", english: "SC" },
    {
      value: "senai-thalaivar",
      tamil: "செனைக் தலைவர்",
      english: "Senai Thalaivar",
    },
    { value: "sourashtra", tamil: "சௌராஷ்டிர", english: "Sourashtra" },
    { value: "st", tamil: "ST", english: "ST" },
    { value: "udayar", tamil: "உடையர்", english: "Udayar" },
    {
      value: "uppillia-naicker",
      tamil: "உப்பில்லிய நாயக்கர்",
      english: "Uppillia Naicker",
    },
    { value: "vallambar", tamil: "வல்லம்பர்", english: "Vallambar" },
    { value: "valluvan", tamil: "வல்லுவன்", english: "Valluvan" },
    { value: "valluvan-sc", tamil: "வல்லுவன் (SC)", english: "Valluvan (SC)" },
    { value: "valluvar", tamil: "வள்ளுவர்", english: "Valluvar" },
    { value: "vannar", tamil: "வண்ணார்", english: "Vannar" },
    {
      value: "vannia-kula-kashatriyar",
      tamil: "வண்ணியா குல கஷ்டிரியர்",
      english: "Vannia Kula Kashatriyar",
    },
    { value: "vanniar", tamil: "வண்ணியார்", english: "Vanniar" },
    { value: "veera-saivam", tamil: "வீர சைவம்", english: "Veera Saivam" },
    {
      value: "veera-selva-lingayath",
      tamil: "வீர செல்வ லிங்காயத்",
      english: "Veera Selva Lingayath",
    },
    {
      value: "veerassivam-thambirar",
      tamil: "வீரச்சிவம் (தம்பிரர்)",
      english: "Veerassivam (Thambirar)",
    },
    { value: "vellalar", tamil: "வேள்ளாளர்", english: "Vellalar" },
    { value: "viswakarma", tamil: "விசுவகார்மா", english: "Viswakarma" },
    { value: "vokkaliga", tamil: "வொக்காலிகா", english: "Vokkaliga" },
    { value: "yadav", tamil: "யாதவ்", english: "Yadav" },
    { value: "yogeeswarar", tamil: "யோகீஸ்வரர்", english: "Yogeeswarar" },
  ];

  const christianCasteOptions = [
    {
      value: "chr-knanaya-jacobite",
      tamil: "கிறிஸ்தவர்- கண்ணாயா ஜேக்கோபைட்",
      english: "Chr- Knanaya Jacobite",
    },
    {
      value: "chr-born-again",
      tamil: "கிறிஸ்தவர்- பிறப்பு மீண்டும்",
      english: "Chr-Born Again",
    },
    {
      value: "chr-bretheren",
      tamil: "கிறிஸ்தவர்- பிரெத்ரென்",
      english: "Chr-Bretheren",
    },
    {
      value: "chr-church-of-south-india",
      tamil: "கிறிஸ்தவர்- தென்னிந்திய சர்ச்",
      english: "Chr-Church of South India",
    },
    {
      value: "chr-evangelist",
      tamil: "கிறிஸ்தவர்- ஈவான்ஜெலிஸ்ட்",
      english: "Chr-Evangelist",
    },
    {
      value: "chr-intercaste",
      tamil: "கிறிஸ்தவர்- இண்டர்கேஸ்ட்",
      english: "Chr-Intercaste",
    },
    {
      value: "chr-jacobite",
      tamil: "கிறிஸ்தவர்- ஜேக்கோபைட்",
      english: "Chr-Jacobite",
    },
    {
      value: "chr-knanaya",
      tamil: "கிறிஸ்தவர்- கண்ணாயா",
      english: "Chr-Knanaya",
    },
    {
      value: "chr-knanaya-catholic",
      tamil: "கிறிஸ்தவர்- கண்ணாயா கத்தோலிக்க",
      english: "Chr-Knanaya Catholic",
    },
    {
      value: "chr-latin-catholic",
      tamil: "கிறிஸ்தவர்- லத்தீன் கத்தோலிக்க",
      english: "Chr-Latin Catholic",
    },
    {
      value: "chr-malankara",
      tamil: "கிறிஸ்தவர்- மலங்கரா",
      english: "Chr-Malankara",
    },
    {
      value: "chr-marthoma",
      tamil: "கிறிஸ்தவர்- மார்த்தோமா",
      english: "Chr-Marthoma",
    },
    { value: "chr-others", tamil: "கிறிஸ்தவர்- மற்றவை", english: "Chr-Others" },
    {
      value: "chr-pentacost",
      tamil: "கிறிஸ்தவர்- பென்டகோஸ்ட்",
      english: "Chr-Pentacost",
    },
    {
      value: "chr-roman-catholic",
      tamil: "கிறிஸ்தவர்- ரோமன் கத்தோலிக்க",
      english: "Chr-Roman Catholic",
    },
    {
      value: "chr-syrian-catholic",
      tamil: "கிறிஸ்தவர்- சிரியன் கத்தோலிக்க",
      english: "Chr-Syrian Catholic",
    },
    {
      value: "chr-syrian-jacobite",
      tamil: "கிறிஸ்தவர்- சிரியன் ஜேக்கோபைட்",
      english: "Chr-Syrian Jacobite",
    },
    {
      value: "chr-syrian-orthodox",
      tamil: "கிறிஸ்தவர்- சிரியன் ஆர்த்தடாக்ஸ்",
      english: "Chr-Syrian Orthodox",
    },
    {
      value: "chr-syro-malabar",
      tamil: "கிறிஸ்தவர்- சைரோ மலபார்",
      english: "Chr-Syro Malabar",
    },
    {
      value: "chr-unspecified",
      tamil: "கிறிஸ்தவர்- குறிப்பிடப்படாத",
      english: "Chr-Unspecified",
    },
  ];

  const muslimCasteOptions = [
    { value: "99", tamil: "முஸ்-அன்சாரி", english: "Mus-Ansari" },
    { value: "100", tamil: "முஸ்-அரைன்", english: "Mus-Arain" },
    { value: "101", tamil: "முஸ்-அவான்", english: "Mus-Awan" },
    { value: "102", tamil: "முஸ்-போஹ்ரா", english: "Mus-Bohra" },
    { value: "103", tamil: "முஸ்-டெக்கானி", english: "Mus-Dekkani" },
    { value: "104", tamil: "முஸ்-டுடேகுலா", english: "Mus-Dudekula" },
    { value: "105", tamil: "முஸ்-ஹனாஃபி", english: "Mus-Hanafi" },
    { value: "106", tamil: "முஸ்-இண்டர்கேஸ்ட்", english: "Mus-Intercaste" },
    { value: "107", tamil: "முஸ்-கோஜா", english: "Mus-Khoja" },
    { value: "108", tamil: "முஸ்-லெப்பை", english: "Mus-Lebbai" },
    { value: "109", tamil: "முஸ்-மாலிக்", english: "Mus-Malik" },
    { value: "110", tamil: "முஸ்-மப்பிலா", english: "Mus-Mapila" },
    { value: "111", tamil: "முஸ்-மரைக்கார்", english: "Mus-Maraicar" },
    { value: "112", tamil: "முஸ்-மேமன்", english: "Mus-Memon" },
    { value: "113", tamil: "முஸ்-முகல்", english: "Mus-Mughal" },
    { value: "114", tamil: "முஸ்-மற்றவை", english: "Mus-Others" },
    { value: "115", tamil: "முஸ்-பதான்", english: "Mus-Pathan" },
    { value: "116", tamil: "முஸ்-குரேஷி", english: "Mus-Qureshi" },
    { value: "117", tamil: "முஸ்-ராஜ்பூத்", english: "Mus-Rajput" },
    { value: "118", tamil: "முஸ்-ரௌத்தர்", english: "Mus-Rowther" },
    { value: "119", tamil: "முஸ்-ஷாஃபி", english: "Mus-Shafi" },
    { value: "120", tamil: "முஸ்-ஷெய்க்", english: "Mus-Sheikh" },
    { value: "121", tamil: "முஸ்-சித்திகி", english: "Mus-Siddiqui" },
    { value: "122", tamil: "முஸ்-சையத்", english: "Mus-Syed" },
    { value: "123", tamil: "முஸ்-குறிப்பிடப்படாத", english: "Mus-UnSpecified" },
    { value: "124", tamil: "நுஸ்-ஜாட்", english: "Nus-Jat" },
  ];

  const getCasteLabel = (caste) => {
    return language === "tamil" ? caste.tamil : caste.english;
  };

  const handlePreviousStep = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (formData.sibling_count < 0) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       sibling_count: "Sibling count cannot be negative",
  //     }));
  //     setTouched((prev) => ({ ...prev, sibling_count: true }));
  //     return;
  //   }

  //   const isValid = validateForm();
  //   if (!isValid) {
  //     setSubmitStatus("error");
  //     showToast("Form validation failed", "error");
  //     return;
  //   }

  //   try {
  //     const formDataToSend = new FormData();

  //     // Append fields properly
  //     Object.keys(formData).forEach((key) => {
  //       if (key === "photo" && formData.photo instanceof File) {
  //         formDataToSend.append("photo", formData.photo);
  //       } else if (
  //         (key === "photos" || key === "horoscope_documents") &&
  //         Array.isArray(formData[key])
  //       ) {
  //         formData[key].forEach((file, index) => {
  //           if (file instanceof File) {
  //             formDataToSend.append(key, file);
  //           } else {
  //             console.warn(`Skipping invalid file at index ${index}:`, file);
  //           }
  //         });
  //       } else if (formData[key] !== undefined && formData[key] !== null) {
  //         formDataToSend.append(key, formData[key]);
  //       }
  //     });

  //     formDataToSend.append("user_type", "user");

  //     // Debugging: Check FormData before sending
  //     console.log("Final FormData content:");
  //     for (let [key, value] of formDataToSend.entries()) {
  //       console.log(key, value);
  //     }

  //     const response = await fetch(
  //       "https://backend.newbrindha.com/matrimony/register",
  //       {
  //         method: "POST",
  //         body: formDataToSend,
  //       }
  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       setSubmitStatus("success");
  //       showToast(null, "success");

  //       setTimeout(() => {
  //         navigate("/login");
  //       }, 1000);
  //     } else {
  //       const errorData = await response.json();
  //       console.error("Registration failed:", errorData);

  //       setSubmitStatus("error");

  //       let errorMessage = "Registration failed";

  //       if (errorData?.detail) {
  //         if (typeof errorData.detail === "string" && errorData.detail.trim() !== "Error:") {
  //           errorMessage = errorData.detail;
  //         } else {
  //           errorMessage = "Something went wrong. Please try again.";
  //         }
  //       } else if (errorData?.message) {
  //         errorMessage = errorData.message;
  //       }

  //       showToast(errorMessage, "error");
  //     }

  //   } catch (error) {
  //     console.error("Error submitting form:", error);
  //     setSubmitStatus("error");
  //     showToast("Error submitting form", "error");
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.sibling_count < 0) {
      setErrors((prev) => ({
        ...prev,
        sibling_count: "Sibling count cannot be negative",
      }));
      setTouched((prev) => ({ ...prev, sibling_count: true }));
      return;
    }

    const isValid = validateForm();
    if (!isValid) {
      setSubmitStatus("error");
      showToast("Form validation failed", "error");
      return;
    }

    // Show confirmation popup instead of submitting immediately
    setShowConfirmationPopup(true);
  };

  // Add this new function to handle the actual submission after confirmation
  const handleConfirmedSubmit = async () => {
  try {
    const formDataToSend = new FormData();

    // Append fields properly
    Object.keys(formData).forEach((key) => {
      if (key === "photo" && formData.photo instanceof File) {
        formDataToSend.append("photo", formData.photo);
      } else if (
        (key === "photos" || key === "horoscope_documents") &&
        Array.isArray(formData[key])
      ) {
        formData[key].forEach((file, index) => {
          if (file instanceof File) {
            formDataToSend.append(key, file);
          }
        });
      } else if (formData[key] !== undefined && formData[key] !== null) {
        // Handle array fields (convert to comma-separated strings)
        if (Array.isArray(formData[key])) {
          formDataToSend.append(key, formData[key].join(","));
        } else {
          formDataToSend.append(key, formData[key]);
        }
      }
    });

    formDataToSend.append("user_type", "user");

    const response = await fetch(
      "https://backend.newbrindha.com/matrimony/register",
      {
        method: "POST",
        body: formDataToSend,
      },
    );

    if (response.ok) {
      const data = await response.json();
      setSubmitStatus("success");
      showToast(null, "success");

      setTimeout(() => {
        navigate("/login");
      }, 1000);
    } else {
      const errorData = await response.json();
      console.error("Registration failed:", errorData);

      setSubmitStatus("error");
      showToast(null, "error");

      let errorMessage = "Registration failed";
      if (errorData.detail) {
        if (typeof errorData.detail === "string") {
          errorMessage = errorData.detail;
        } else if (Array.isArray(errorData.detail)) {
          errorMessage = errorData.detail
            .map((err) => err.msg || JSON.stringify(err))
            .join(", ");
        } else if (typeof errorData.detail === "object") {
          errorMessage = JSON.stringify(errorData.detail);
        }
      }

      showToast(errorMessage, "error");
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    setSubmitStatus("error");
    showToast("Error submitting form", "error");
  } finally {
    setShowConfirmationPopup(false);
  }
};

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowLanguageDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const translations = {
    english: {
      createAccount: "Find Your Match Today",
      joinCommunity: "The Path to Love Start here - Join our Community!",
      uploadPhoto: "Add Profile",
      uploadPhotos: "Attach Photos",
      fullName: "Full Name",
      age: "Age",
      gender: "Gender",
      dateOfBirth: "Date of Birth",
      height: "Height (cm)",
      weight: "Weight (kg)",
      email: "Email",
      phoneNumber: "Phone Number",
      occupation: "Occupation",
      annualIncome: "Annual Income (₹)",
      password: "Password",
      confirmpassword: "Marital Status",
      registerNow: "Register Now",
      selectGender: "Select Gender",
      male: "Male",
      female: "Female",
      next: "Next",
      previous: "Previous",
      loginText: "Already have an account?",
      loginButton: "Login",
      workType: "Work Type",
      company: "Company",
      education: "Education",
      workLocation: "Work Location",
      workCountry: "Work Country",
      motherName: "Mother Name",
      fatherName: "Father Name",
      siblingCount: "Sibling Count",
      bloodGroup: "Blood Group",
      native: "Native",
      motherOccupation: "Mother Occupation",
      fatherOccupation: "Father Occupation",
      religion: "Religion",
      caste: "Caste",
      subCaste: "Sub Caste",
      motherTongue: "Mother Tongue",
      profileCreatedBy: "Profile Created By",
      address: "Address",
      nakshatra: "Nakshatra",
      birthTime: "Birth Time",
      birthPlace: "Birth Place",
      rashi: "Rashi",
      ascendent: "Ascendent",
      horoscopeDocuments: "Attach Horoscope",
      elderBrother: "Elder Brother",
      elderSister: "Elder Sister",
      youngerBrother: "Younger Brother",
      youngerSister: "Younger Sister",
      selectSibling: "Select sibling Type",
      matrimonyId: "Matrimony ID",
      quarter: "Quarter ",
      dosham: "Dosham",
      select: "Select",
      putthira_dosham: "Putthira Dosham",
      naaga_dosham: "Naaga Dosham",
      sevvai_dosham: "Sevvai Dosham",
      rahu_chandra_grahana_dosham: "Rahu Chandra Grahana Dosham",
      kaala_sarpa_dosham: "Kaala Sarpa Dosham",
      mangala_dosham: "Mangala Dosham",
      naadi_dosham: "Naadi Dosham",
      other: "Other",
      specifyLabel: "Please specify",
      specifyPlaceholder: "Enter details",
      hindu: "Hindu",
      muslim: "muslim",
      christian: "christian",
      PartnerPreferences: "Partner Preference",
      ageRange: "Age Range",
      minAge: "Min Age",
      maxAge: "Max Age",
      heightRange: "Height Range",
      minHeight: "Min Height (cm)",
      maxHeight: "Max Height (cm)",
      workingStatus: "Working Status",
      selectStatus: "Select Status",
      working: "Working",
      notWorking: "Not Working",
      preferredLocation: "Preferred Location",
      placeholder: "Enter preferred location",
      yes: "Yes",
      no: "No",
      elder: "Elder Brother / Elder Sister",
      younger: "Younger Brother / Younger Sister",
      emailRequired: "Email is required",
      passwordRequired: "Password is required",
      ageRequired: "Age is required",
      dateOfBirthRequired: "Date of birth is required",
      genderRequired: "Gender is required",
      photoRequired: "Photo is required",
      subcaste: "Sub Caste",
      placeholders: "Enter Your Subcaste",
      castes: "select your caste",
    },
    tamil: {
      createAccount: "கணக்கை உருவாக்கவும்",
      joinCommunity:
        "எங்கள் சமூகத்தில் சேர்ந்து உங்கள் சரியான பொருத்தத்தைக் கண்டறியவும்",
      uploadPhoto: "புகைப்படத்தை பதிவேற்றவும்",
      uploadPhotos: "புகைப்படங்களை பதிவேற்றவும்",
      fullName: "முழு பெயர்",
      age: "வயது",
      gender: "பாலினம்",
      dateOfBirth: "பிறந்த தேதி",
      height: "உயரம் (செ.மீ.)",
      weight: "எடை (கி.கி.)",
      email: "மின்னஞ்சல்",
      phoneNumber: "தொலைபேசி எண்",
      occupation: "தொழில்",
      annualIncome: "ஆண்டு வருமானம் (₹)",
      password: "கடவுச்சொல்",
      registerNow: "இப்போது பதிவு செய்யுங்கள்",
      selectGender: "பாலினம்",
      male: "ஆண்",
      female: "பெண்",
      next: "அடுத்தது",
      previous: "முந்தைய",
      bloodGroup: "இரத்த வகை",
      confirmpassword: "திருமண நிலை",
      loginText: "ஏற்கனவே கணக்கு உள்ளதா?",
      loginButton: " உள்நுழைக",
      workType: "வேலை வகை",
      company: "நிறுவனம்",
      education: "கல்வி நிலை",
      workLocation: "வேலை இடம்",
      workCountry: "வேலை நாடு",
      motherName: "தாயின் பெயர்",
      fatherName: "தந்தையின் பெயர்",
      siblingCount: "சகோதரர்கள் எண்ணிக்கை",
      native: "சொந்த ஊர்",
      motherOccupation: "தாயின் தொழில்",
      fatherOccupation: "தந்தையின் தொழில்",
      religion: "மதம்",
      caste: "சாதி",
      subCaste: "உட்பிரிவு",
      motherTongue: "தாய்மொழி",
      profileCreatedBy: "சுயவிவரத்தை உருவாக்கியவர்",
      address: "முகவரி",
      nakshatra: "நட்சத்திரம்",
      birthTime: "பிறந்த நேரம்",
      birthPlace: "பிறந்த இடம்",
      rashi: "ராசி",
      ascendent: "லக்கினம்",
      horoscopeDocuments: "ஜோதிட ஆவணங்கள்",
      elderBrother: "மூத்த சகோதரன்",
      elderSister: "மூத்த சகோதரி",
      youngerBrother: "இளைய சகோதரன்",
      youngerSister: "இளைய சகோதரி",
      selectSibling: "உடன்பிறப்பு வகையைத் தேர்ந்தெடுக்கவும்",
      matrimonyId: "மேட்ரிமோனி ஐடி",
      quarter: "பாதம்",
      dosham: "தோஷம்",
      select: "தேர்ந்தெடுக்கவும்",
      putthira_dosham: "புத்திர தோஷம்",
      naaga_dosham: "நாக தோஷம்",
      sevvai_dosham: "செவ்வாய் தோஷம்",
      rahu_chandra_grahana_dosham: "இரா் சேந்திர கிரஹண தோஷம்",
      kaala_sarpa_dosham: "கால சர்ப தோஷம்",
      mangala_dosham: "மங்கள தோஷம்",
      naadi_dosham: "நாடி தோஷம்",
      other: "மற்றவை",
      specifyLabel: "தயவுசெய்து குறிப்பிடவும்",
      specifyPlaceholder: "விவரங்களை உள்ளிடவும்",
      hindu: "ஹிந்து",
      muslim: "முஸ்லிம்",
      christian: "கிறிஸ்துவர்",
      PartnerPreferences: "பார்ட்னர் முன்னுரிமைகள்",
      ageRange: "வயது வரம்பு",
      minAge: "குறைந்தபட்ச வயது",
      maxAge: "அதிகபட்ச வயது",
      heightRange: "உயரம் வரம்பு",
      minHeight: "குறைந்தபட்ச உயரம் (செ.மீ)",
      maxHeight: "அதிகபட்ச உயரம் (செ.மீ)",
      workingStatus: "வேலை நிலை",
      selectStatus: "நிலை தேர்ந்தெடுக்கவும்",
      working: "வேலை செய்யும்",
      notWorking: "வேலை செய்யவில்லை",
      preferredLocation: "முன்னுரிமை இடம்",
      placeholder: "முன்னுரிமை இடத்தை உள்ளிடவும்",
      yes: "ஆம்",
      no: "இல்லை",
      elder: "மூத்த சகோதரர் / மூத்த சகோதரி",
      younger: "இளைய சகோதரர் / இளைய சகோதரி",
      emailRequired: "மின்னஞ்சல் தேவை",
      passwordRequired: "கடவுச்சொல் தேவை",
      ageRequired: "வயது தேவை",
      dateOfBirthRequired: "பிறந்த தேதி தேவை",
      genderRequired: "பாலினம் தேவை",
      photoRequired: "புகைப்படம் தேவை",
      subcaste: "உட்பிரிவு",
      placeholders: "முன்னுரிமை உட்பிரிவு உள்ளிடவும்",
      castes: "சாதியைத் தேர்வு செய்யவும்",
    },
  };

  const casteData = {
    hindu: [
      {
        en: "Brahmin",
        ta: "பிராமணர்",
        subCastes: [
          { en: "Iyer", ta: "ஐயர்" },
          { en: "Iyengar", ta: "ஐயங்கார்" },
          { en: "Namboothiri", ta: "நம்பூதிரி" },
          { en: "Deshastha", ta: "தேஷஸ்தா" },
          { en: "Chitpavan", ta: "சித்பவான்" },
          { en: "Gaud Saraswat", ta: "கௌட் சரஸ்வத்" },
          { en: "Virgokubj", ta: "கன்யாகுஜ்" },
          { en: "Sri Vaishnava", ta: "ஸ்ரீ வைணவா" },
          { en: "Havyaka", ta: "ஹவ்யகா" },
          { en: "Shivalli", ta: "சிவல்லி" },
          { en: "Badaganadu", ta: "படகனாடு" },
        ],
      },
      {
        en: "Kshatriya",
        ta: "க்ஷத்ரியர்",
        subCastes: [
          { en: "Rajput", ta: "ராஜ்புத்திரர்" },
          { en: "Rathor", ta: "ரத்தோர்" },
          { en: "Chauhan", ta: "சவான்" },
          { en: "Bhati", ta: "பாட்டி" },
          { en: "Solanki", ta: "சோலங்கி" },
          { en: "Parihar", ta: "பரியார்" },
          { en: "Baghel", ta: "பகேல்" },
          { en: "Gaur", ta: "கௌர்" },
          { en: "NiAquarius", ta: "நிகும்பா" },
          { en: "Raghuvanshi", ta: "ரகுவன்ஷி" },
          { en: "Badgujar", ta: "பாட்஗ுஜர்" },
        ],
      },
      {
        en: "Vaishya",
        ta: "வைசியர்",
        subCastes: [
          { en: "Baig Vaishya", ta: "பைக் வைசியர்" },
          { en: "Jain Vaishya", ta: "ஜெயின் வைசியர்" },
          { en: "Gaud Vaishya", ta: "கௌத் வைசியர்" },
          { en: "Bais Vaishya", ta: "பைஸ் வைசியர்" },
          { en: "Kath Bania", ta: "காத் பணியா" },
          { en: "Kaithal Vaishya", ta: "கைத்தல் வைசியர்" },
          { en: "Bangiya Vaishya", ta: "பங்கியா வைசியர்" },
          { en: "Komati", ta: "கோமதி" },
          { en: "Rajapuri", ta: "ராஜபூரி" },
          { en: "Bania", ta: "பணியா" },
          { en: "Chetti or Chettiyar", ta: "செட்டி அல்லது செட்டியார்" },
          { en: "Vanis", ta: "வாணியர்" },
          { en: "Bandekara", ta: "பாண்டேகாரா" },
        ],
      },
      {
        en: "Sudra",
        ta: "சூத்திரர்",
        subCastes: [
          { en: "Pundrakas", ta: "புந்திரகாஸ்" },
          { en: "Codas", ta: "கொடாஸ்" },
          { en: "Dravidas", ta: "த்ராவிடர்" },
          { en: "Kambojas", ta: "கம்போஜர்கள்" },
          { en: "Yavanas", ta: "யவனர்கள்" },
          { en: "Sakas", ta: "சாக்கள்" },
          { en: "Paradas", ta: "பாரதாஸ்" },
          { en: "Pahlavas", ta: "பாஹ்லவா" },
          { en: "Chinas", ta: "சினா" },
          { en: "Kiratas", ta: "கிராதர்கள்" },
          { en: "Daradas", ta: "தராடர்கள்" },
          { en: "Khasas", ta: "காஸாஸ்" },
          { en: "Kunbi", ta: "குண்பி" },
          { en: "Lodhi", ta: "லோதி" },
          { en: "Mallaah", ta: "மல்லாஹ்" },
          { en: "Mochi", ta: "மொச்சி" },
          { en: "Pasi", ta: "பாசி" },
          { en: "Patidar", ta: "படிதார்" },
          { en: "Rohit", ta: "ரோஹித்" },
        ],
      },
      {
        en: "Adi Dravidar",
        ta: "ஆதி திராவிடர்",
        subCastes: [
          { en: "Devendrakulathan", ta: "தேவந்திரகுலாதான்" },
          { en: "Kadaiyan", ta: "கடையன்" },
          { en: "Kalladi", ta: "கள்ளாடி" },
          { en: "Kudumban", ta: "குடும்பன்" },
          { en: "Pallan", ta: "பள்ளன்" },
          { en: "Pannadi", ta: "பண்ணாடி" },
          { en: "Vathiriyan", ta: "வத்திரியன்" },
        ],
      },
      {
        en: "Nadar",
        ta: "நாடார்",
        subCastes: [
          {
            en: "Karukkupattaiyathar (Palmrya climbers)",
            ta: "கருக்குபட்டையாதர் (பாமரியா ஏறியவர்கள்)",
          },
          { en: "Mel-nattar", ta: "மேல் நாட்டுர்" },
          { en: "Nattathi", ta: "நாட்டத்தி" },
          { en: "Kodikal", ta: "கொடிகல்" },
          { en: "Kalla", ta: "கள்ளா" },
          { en: "Christian Nadars", ta: "கிறிஸ்தவ நாடார்" },
        ],
      },
      {
        en: "Thevar",
        ta: "தேவர்",
        subCastes: [
          { en: "Agamudayar", ta: "அகமுதயர்" },
          { en: "Kallar", ta: "கள்ளர்" },
          { en: "Maravar", ta: "மாறவர்" },
        ],
      },
      {
        en: "Gounder",
        ta: "கவுண்டர்",
        subCastes: [
          { en: "Kongu Vellalars", ta: "கோங்கு வெள்ளாளர்" },
          { en: "Vellala Gounder", ta: "வெள்ளாளா கவுண்டர்" },
          { en: "Nattu Gounder", ta: "நாட்டு கவுண்டர்" },
          { en: "Narambukkatti Gounder", ta: "நரம்புக்கட்டி கவுண்டர்" },
          { en: "Tirumudi Vellalar", ta: "திருமுடி வெள்ளாளர்" },
          { en: "Thondu Vellalar", ta: "தொண்டு வெள்ளாளர்" },
          { en: "Pala Gounder", ta: "பாலா கவுண்டர்" },
          { en: "Poosari", ta: "பூசாரி" },
          { en: "Gounder", ta: "கவுண்டர்" },
          { en: "Anuppa Vellala Gounder", ta: "அணுப்பு வெள்ளாலா கவுண்டர்" },
          { en: "Kurumba Gounder", ta: "குரும்பா கவுண்டர்" },
          { en: "Padaithalai Gounder", ta: "படைத்தலை கவுண்டர்" },
          { en: "Chendalai Gounder", ta: "செண்டலை கவுண்டர்" },
          {
            en: "Pavalankatti Vellala Gounder",
            ta: "பவலன்கட்டி வெள்ளாலா கவுண்டர்",
          },
          { en: "Pallavellala Gounder", ta: "பல்லவெல்லாலா கவுண்டர்" },
          { en: "Sanku", ta: "சங்கு" },
          { en: "Vellala Gounder", ta: "வெள்ளாலா கவுண்டர்" },
          { en: "Rathinagiri", ta: "ரத்தினகிரி" },
        ],
      },
      {
        en: "Vanniyar",
        ta: "வன்னியர்",
        subCastes: [
          { en: "Vanniakula Kshatriya", ta: "வண்ணியகுல க்ஷத்ரியர்" },
          { en: "Vanniyar", ta: "வன்னியர்" },
          { en: "Vanniya", ta: "வண்ணிய" },
          { en: "Vannia Gounder", ta: "வண்ணியா கவுண்டர்" },
          { en: "Gownder", ta: "கவுண்டர்" },
          { en: "Gounder", ta: "கவுண்டர்" },
          { en: "Kander", ta: "காண்டர்" },
          { en: "Padayachi", ta: "படையாச்சி" },
          { en: "Palli", ta: "பள்ளி" },
          { en: "Agnikula Kshatriya", ta: "அக்னிகுல க்ஷத்ரியர்" },
          { en: "Naicker", ta: "நாயக்கர்" },
          { en: "Nayakar", ta: "நாயக்கர்" },
          { en: "Reddiar", ta: "ரெட்டியார்" },
          { en: "Rayar", ta: "ராயர்" },
          { en: "Mazhavarayar", ta: "மழவராயர்" },
          { en: "Kalingarayar", ta: "காளிங்கராயர்" },
        ],
      },
      {
        en: "Vellalar",
        ta: "வெள்ளாளர்",
        subCastes: [
          { en: "Arunattu Vellalar", ta: "அருணத்து வெள்ளாளர்" },
          { en: "Chozhia Vellalar", ta: "சோழிய வெள்ளாளர்" },
          {
            en: "Devendrakula Vellalar",
            ta: "தேவந்திர குல வெள்ளாளர் (பள்ளர் அல்லது மல்லர்)",
          },
          { en: "Cancerrthar Vellalar", ta: "கார்கதர் வெள்ளாளர்" },
          { en: "Kodikaal Vellalar", ta: "கொடிக்கால் வெள்ளாளர்" },
          { en: "Kondaikatti Vellalar", ta: "கொண்டைக்கட்டி வெள்ளாளர்" },
          { en: "Kongu Vellalar", ta: "கோங்கு வெள்ளாளர் (கோங்கு கவுண்டர்)" },
          {
            en: "Nankudi Vellalar",
            ta: "நாங்குடி வெள்ளாளர் (சிவகலை பிள்ளைமார்)",
          },
          { en: "Sri Lankan Vellalar", ta: "இலங்கை வெள்ளாளர்" },
          { en: "Thondaimandala Vellalar", ta: "தொண்டைமண்டல வெள்ளாளர்" },
          { en: "Thuluva Vellalar", ta: "தூழுவா வெள்ளாளர்" },
          { en: "Virakodi Vellala", ta: "விரகோடி வெள்ளாளர்" },
          { en: "Podikara Vellala", ta: "பொடிகரா வெள்ளாளர்" },
          { en: "Kuga Vellala", ta: "கூக வெள்ளாளர்" },
        ],
      },
    ],
    muslim: [
      {
        en: "Sunni",
        ta: "சுன்னி",
        subCastes: [
          { en: "Hanafi", ta: "ஹனஃபி" },
          { en: "Shafi", ta: "ஷாஃபி" },
          { en: "Maliki", ta: "மாலிகி" },
        ],
      },
      {
        en: "Shia",
        ta: "ஷியா",
        subCastes: [
          { en: "Ismaili", ta: "இஸ்மைலி" },
          { en: "Ithna Ashari", ta: "இத்தினா ஆஷாரி" },
        ],
      },
      {
        en: "Mappila",
        ta: "மாப்பிள்ளை",
        subCastes: [{ en: "Moplah", ta: "மொப்பிளா" }],
      },
      {
        en: "Lebbai",
        ta: "லெப்பை",
        subCastes: [{ en: "Labbay", ta: "லப்பாய்" }],
      },
      {
        en: "Rowther",
        ta: "ரவுத்தர்",
        subCastes: [{ en: "Rowther", ta: "ரவுத்தர்" }],
      },
      { en: "Syed", ta: "சையது", subCastes: [{ en: "Sayyid", ta: "சையித்" }] },
    ],
    christian: [
      {
        en: "Roman Catholic",
        ta: "ரோமன் கத்தோலிக்க",
        subCastes: [
          { en: "Latin Catholic", ta: "லத்தீன் கத்தோலிக்க" },
          { en: "Syrian Catholic", ta: "சிரியன் கத்தோலிக்க" },
        ],
      },
      {
        en: "Protestant",
        ta: "புராட்டஸ்டன்ட்",
        subCastes: [
          { en: "Wesleyan", ta: "வெஸ்லேயன்" },
          { en: "Baptist", ta: "பேப்டிஸ்ட்" },
        ],
      },
      {
        en: "Syrian Christian",
        ta: "சிரியன் கிறிஸ்தவர்",
        subCastes: [{ en: "Malankara Syrian", ta: "மலைங்கர சிரியன்" }],
      },
      {
        en: "Latin Catholic",
        ta: "லத்தீன் கத்தோலிக்க",
        subCastes: [
          { en: "Roman Catholic", ta: "ரோமன் கத்தோலிக்க" },
          { en: "Goan Catholic", ta: "கோயன் கத்தோலிக்க" },
        ],
      },
      {
        en: "CSI",
        ta: "சிஎஸ்ஐ",
        subCastes: [
          { en: "Church of South India", ta: "தென் இந்தியா திருஆயிரம்" },
        ],
      },
      {
        en: "Methodist",
        ta: "மெதடிஸ்ட்",
        subCastes: [{ en: "Wesleyan Methodist", ta: "வெஸ்லேயன் மெத்தடிஸ்ட்" }],
      },
    ],
  };

  const nakshatraRasiMap = {
    english: {
      Ashwini: ["Aries", "Aries", "Aries", "Aries"],
      Bharani: ["Aries", "Aries", "Aries", "Aries"],
      Krittika: ["Aries", "Aries", "Aries", "Taurus"],
      Rohini: ["Taurus", "Taurus", "Taurus", "Taurus"],
      Mrigashira: ["Taurus", "Taurus", "Gemini", "Gemini"],
      Ardra: ["Gemini", "Gemini", "Gemini", "Gemini"],
      Punarvasu: ["Gemini", "Gemini", "Cancer", "Cancer"],
      Pushya: ["Cancer", "Cancer", "Cancer", "Cancer"],
      Ashlesha: ["Cancer", "Cancer", "Cancer", "Cancer"],
      Magha: ["Leo", "Leo", "Leo", "Leo"],
      PurvaPhalguni: ["Leo", "Leo", "Leo", "Leo"],
      UttaraPhalguni: ["Leo", "Leo", "Virgo", "Virgo"],
      Hasta: ["Virgo", "Virgo", "Virgo", "Virgo"],
      Chitra: ["Virgo", "Libra", "Libra", "Libra"],
      Swati: ["Libra", "Libra", "Libra", "Libra"],
      Vishakha: ["Libra", "Libra", "Scorpio", "Scorpio"],
      Anuradha: ["Scorpio", "Scorpio", "Scorpio", "Scorpio"],
      Jyeshtha: ["Scorpio", "Scorpio", "Scorpio", "Scorpio"],
      Moola: ["Sagittarius", "Sagittarius", "Sagittarius", "Sagittarius"],
      PurvaAshadha: [
        "Sagittarius",
        "Sagittarius",
        "Sagittarius",
        "Sagittarius",
      ],
      UttaraAshadha: ["Sagittarius", "Sagittarius", "Capricorn", "Capricorn"],
      Shravana: ["Capricorn", "Capricorn", "Capricorn", "Capricorn"],
      Dhanishta: ["Capricorn", "Capricorn", "Aquarius", "Aquarius"],
      Shatabhisha: ["Aquarius", "Aquarius", "Aquarius", "Aquarius"],
      PurvaBhadrapada: ["Aquarius", "Aquarius", "Pisces", "Pisces"],
      UttaraBhadrapada: ["Pisces", "Pisces", "Pisces", "Pisces"],
      Revati: ["Pisces", "Pisces", "Pisces", "Pisces"],
    },
    tamil: {
      அஷ்வினி: ["மேஷம்", "மேஷம்", "மேஷம்", "மேஷம்"],
      பரணி: ["மேஷம்", "மேஷம்", "மேஷம்", "மேஷம்"],
      கிருத்திகை: ["மேஷம்", "மேஷம்", "மேஷம்", "ரிஷபம்"],
      ரோஹினி: ["ரிஷபம்", "ரிஷபம்", "ரிஷபம்", "ரிஷபம்"],
      மிருகசீரிடம்: ["ரிஷபம்", "ரிஷபம்", "ரிஷபம்", "ரிஷபம்"],
      திருவாதிரை: ["மிதுனம்", "மிதுனம்", "மிதுனம்", "மிதுனம்"],
      புனர்பூசம்: ["மிதுனம்", "மிதுனம்", "கடகம்", "கடகம்"],
      பூசம்: ["கடகம்", "கடகம்", "கடகம்", "கடகம்"],
      ஆயிலியம்: ["கடகம்", "கடகம்", "கடகம்", "கடகம்"],
      மகம்: ["சிம்மம்", "சிம்மம்", "சிம்மம்", "சிம்மம்"],
      பூரம்: ["சிம்மம்", "சிம்மம்", "சிம்மம்", "சிம்மம்"],
      உத்தரம்: ["சிம்மம்", "சிம்மம்", "கன்னி", "கன்னி"],
      அத்தம்: ["கன்னி", "கன்னி", "கன்னி", "கன்னி"],
      சித்திரை: ["கன்னி", "துலாம்", "துலாம்", "துலாம்"],
      சோதி: ["துலாம்", "துலாம்", "துலாம்", "துலாம்"],
      விசாகம்: ["துலாம்", "துலாம்", "விருஷ்சிகம்", "விருஷ்சிகம்"],
      அனுசம்: ["விருஷ்சிகம்", "விருஷ்சிகம்", "விருஷ்சிகம்", "விருஷ்சிகம்"],
      கேட்டை: ["விருஷ்சிகம்", "விருஷ்சிகம்", "விருஷ்சிகம்", "விருஷ்சிகம்"],
      மூலம்: ["தனுசு", "தனுசு", "தனுசு", "தனுசு"],
      பூராடம்: ["தனுசு", "தனுசு", "தனுசு", "தனுசு"],
      உத்திராடம்: ["தனுசு", "தனுசு", "மகரம்", "மகரம்"],
      அவிட்டம்: ["மகரம்", "மகரம்", "மகரம்", "மகரம்"],
      சதயம்: ["மகரம்", "மகரம்", "கும்பம்", "கும்பம்"],
      ஷடபிஷா: ["கும்பம்", "கும்பம்", "கும்பம்", "கும்பம்"],
      பூரட்டாதி: ["கும்பம்", "கும்பம்", "மீனம்", "மீனம்"],
      உத்திரட்டாதி: ["மீனம்", "மீனம்", "மீனம்", "மீனம்"],
      ரேவதி: ["மீனம்", "மீனம்", "மீனம்", "மீனம்"],
    },
  };

  const [languageData, setLanguageData] = useState(translations[language]);

  const calculateRashi = (nakshatra, quarter) => {
    if (!nakshatra || !quarter) return "";
    const quarterIndex = parseInt(quarter) - 1;
    return nakshatraRasiMap[language]?.[nakshatra]?.[quarterIndex] || "";
  };

  // Update Rashi when Nakshatra or quarter  changes
  useEffect(() => {
    const newRashi = calculateRashi(formData.nakshatra, formData.quarter);
    setFormData((prev) => ({
      ...prev,
      rashi: newRashi,
    }));
  }, [formData.nakshatra, formData.quarter, language]);

  // useEffect(() => {
  //   const storedLanguage = localStorage.getItem("selectedLanguage");
  //   if (storedLanguage) {
  //     setLanguage(storedLanguage);
  //   } else {
  //     navigate("/");
  //   }
  // }, [navigate]);

 const handleSiblingChange = (field, value) => {
  const safeValue = Array.isArray(value) ? value : [];
  
  const totalEntered = 
    (Array.isArray(formData.elder_brother) ? formData.elder_brother.length : 0) +
    (Array.isArray(formData.younger_brother) ? formData.younger_brother.length : 0) +
    (Array.isArray(formData.elder_sister) ? formData.elder_sister.length : 0) +
    (Array.isArray(formData.younger_sister) ? formData.younger_sister.length : 0);

  if (totalEntered >= formData.sibling_count && safeValue.length > (Array.isArray(formData[field]) ? formData[field].length : 0)) {
    return; 
  }

  setFormData((prevFormData) => ({
    ...prevFormData,
    [field]: safeValue,
  }));
};

  const handleSiblingCountChange = (e) => {
    let value =
      e.target.value.trim() === ""
        ? ""
        : Math.max(0, parseInt(e.target.value, 10));
    setFormData({ ...formData, sibling_count: value });

    if (value === "" || value === 0) {
      setFormData({
        ...formData,
        sibling_count: value,
        elder_brother: [],
        younger_brother: [],
        elder_sister: [],
        younger_sister: [],
      });
    }
  };

  // Handle Blur for Validation
  const handleBlur = (field) => {
    setTouched({ ...touched, [field]: true });

    if (field === "sibling_count" && formData.sibling_count === "") {
      setErrors({ ...errors, sibling_count: "Sibling count is required" });
    } else {
      setErrors({ ...errors, sibling_count: "" });
    }
  };

  useEffect(() => {
    setLanguageData(translations[language]);
  }, [language]);

  const nakshatras = Object.keys(nakshatraRasiMap[language] || {});
  const quarters = [1, 2, 3, 4];
//   const quarters = [
//     { value: "Mesha-Ashwini", label: "Mesham - Ashwini (1, 2, 3, 4)" },
//     { value: "Mesha-Bharani", label: "Mesham - Bharani (1, 2, 3, 4)" },
//     { value: "Mesha-Krittika", label: "Mesham - Krittikai (1)" },
//     { value: "Vrishabha-Krittika", label: "Rishabham - Krittikai (2, 3, 4)" },
//     { value: "Vrishabha-Rohini", label: "Rishabham - Rohini (1, 2, 3, 4)" },
//     { value: "Vrishabha-Mrigashira", label: "Rishabham - Mirugashiritam (1, 2)" },
//     { value: "Mithuna-Mrigashira", label: "Mithunam - Mirugashiritam (3, 4)" },
//     { value: "Mithuna-Ardra", label: "Mithunam - Thiruvathirai (1, 2, 3, 4)" },
//     { value: "Mithuna-Punarvasu", label: "Mithunam - Punarpusam (1, 2, 3)" },
//     { value: "Karka-Punarvasu", label: "Kadagam - Punarpusam (4)" },
//     { value: "Karka-Pushya", label: "Kadagam - Pusam (1, 2, 3, 4)" },
//     { value: "Karka-Ashlesha", label: "Kadagam - Ayilyam (1, 2, 3, 4)" },
//     { value: "Simha-Magha", label: "Simmam - Magam (1, 2, 3, 4)" },
//     { value: "Simha-PurvaPhalguni", label: "Simmam - Pooram (1, 2, 3, 4)" },
//     { value: "Simha-UttaraPhalguni", label: "Simmam - Uthiram (1)" },
//     { value: "Kanya-UttaraPhalguni", label: "Kanni - Uthiram (2, 3, 4)" },
//     { value: "Kanya-Hasta", label: "Kanni - Hastham (1, 2, 3, 4)" },
//     { value: "Kanya-Chitra", label: "Kanni - Chitrai (1, 2)" },
//     { value: "Tula-Chitra", label: "Tulaam - Chitrai (3, 4)" },
//     { value: "Tula-Swati", label: "Tulaam - Swathi (1, 2, 3, 4)" },
//     { value: "Tula-Vishakha", label: "Tulaam - Vishakham (1, 2, 3)" },
//     { value: "Vrischika-Vishakha", label: "Viruchigam - Vishakham (4)" },
//     { value: "Vrischika-Anuradha", label: "Viruchigam - Anusham (1, 2, 3, 4)" },
//     { value: "Vrischika-Jyeshtha", label: "Viruchigam - Kettai (1, 2, 3, 4)" },
//     { value: "Dhanu-Moola", label: "Dhanush - Mulam (1, 2, 3, 4)" },
//     { value: "Dhanu-Purvashada", label: "Dhanush - Pooradam (1, 2, 3, 4)" },
//     { value: "Dhanu-Uttarashada", label: "Dhanush - Uttharadam (1)" },
//     { value: "Makara-Uttarashada", label: "Magaram - Uttharadam (2, 3, 4)" },
//     { value: "Makara-Shravana", label: "Magaram - Thiruvonam (1, 2, 3, 4)" },
//     { value: "Makara-Dhanishta", label: "Magaram - Avittam (1, 2)" },
//     { value: "Kumbha-Dhanishta", label: "Kumbham - Avittam (3, 4)" },
//     { value: "Kumbha-Shatabhisha", label: "Kumbham - Shadhayam (1, 2, 3, 4)" },
//     { value: "Kumbha-Purvabhadra", label: "Kumbham - Poorattadhi (1, 2, 3)" },
//     { value: "Meena-Purvabhadra", label: "Meenam - Poorattadhi (4)" },
//     { value: "Meena-Uttarabhadra", label: "Meenam - Uthirattadhi (1, 2, 3, 4)" },
//     { value: "Meena-Revati", label: "Meenam - Revati (1, 2, 3, 4)" }
// ];

  const siblingOptions = [
    {
      value: "elder_brother",
      label: languageData?.elderBrother || "Elder Brother",
    },
    {
      value: "elder_sister",
      label: languageData?.elderSister || "Elder Sister",
    },
    {
      value: "younger_brother",
      label: languageData?.youngerBrother || "Younger Brother",
    },
    {
      value: "younger_sister",
      label: languageData?.youngerSister || "Younger Sister",
    },
  ];

  const handleReligionChange = (field, value) => {
    setFormData({
      ...formData,
      religion: value,
      caste: "", // Reset caste on religion change
      sub_caste: "", // Reset sub-caste
    });
  };

  const handleCasteChange = (value) => {
    setFormData({ ...formData, caste: value, sub_caste: "" }); // Reset sub-caste
  };

  // Handle the sub-caste change
  const handleSubCasteChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      sub_caste: value, // Ensure it updates correctly
    }));
  };

  // Extract the sub-caste options based on the selected caste and religion
  const getSubCasteOptions = () => {
    if (!formData.religion || !formData.caste) return [];

    // Find the selected caste in the casteData object
    const selectedCaste = casteData[formData.religion.toLowerCase()]?.find(
      (caste) => caste.en === formData.caste,
    );

    // Return the sub-castes if available
    return selectedCaste?.subCastes || [];
  };

  const handleCasteSelection = (caste, isChecked) => {
    setFormData((prevState) => {
      let updatedSelectedCastes = [...prevState.selectedCastes];
      if (isChecked) {
        updatedSelectedCastes.push(caste);
      } else {
        updatedSelectedCastes = updatedSelectedCastes.filter(
          (item) => item !== caste,
        );
      }
      return { ...prevState, selectedCastes: updatedSelectedCastes };
    });
  };

  const handleSubCasteSelection = (caste, subCaste, isChecked) => {
    setFormData((prevState) => {
      const updatedSubCastes = { ...prevState.selectedSubCastes };
      if (isChecked) {
        if (!updatedSubCastes[caste]) {
          updatedSubCastes[caste] = [];
        }
        updatedSubCastes[caste].push(subCaste);
      } else {
        updatedSubCastes[caste] = updatedSubCastes[caste]?.filter(
          (item) => item !== subCaste,
        );
      }
      return { ...prevState, selectedSubCastes: updatedSubCastes };
    });
  };

  const handleCheckboxChange = (field, value, isChecked) => {
    setFormData((prev) => ({
      ...prev,
      [field]: isChecked
        ? [...prev[field], value] // Add value
        : prev[field].filter((item) => item !== value), // Remove value
    }));
  };

  const handleReligionChanges = (isChecked, religion) => {
    setFormData((prev) => {
      const updatedReligions = isChecked
        ? [...prev.preferred_religion, religion] // Add if checked
        : prev.preferred_religion.filter((r) => r !== religion); // Remove if unchecked

      return {
        ...prev,
        preferred_religion: updatedReligions,
      };
    });
  };

  const Toaster = ({ toast }) => {
    if (!toast || !toast.type || !toast.message) return null;

    return (
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -50 }}
        className={`fixed top-4 right-4 px-4 py-2 rounded-lg shadow-lg text-white text-sm md:text-base ${
          toast.type === "success"
            ? "bg-green-600"
            : toast.type === "error"
              ? "bg-red-600"
              : "bg-red-600"
        }`}
        style={{ zIndex: 1000 }}
      >
        {toast.message}
      </motion.div>
    );
  };

  const FilePreviewModal = ({ file, onClose }) => {
    if (!file) return null;

    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        transition={{ duration: 0.3 }}
        className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      >
        <motion.div
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -50, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="bg-white p-4 rounded-lg max-w-lg w-full"
        >
          {file.type.startsWith("image/") ? (
            <img
              src={URL.createObjectURL(file)}
              alt="Preview"
              className="w-full h-auto rounded-lg"
            />
          ) : (
            <iframe
              src={URL.createObjectURL(file)}
              className="w-full h-96 rounded-lg"
              title="iframe-file"
            />
          )}
          <button
            onClick={onClose}
            className="mt-4 bg-red-500 text-white px-4 py-2 rounded-full hover:bg-red-600"
          >
            Close
          </button>
        </motion.div>
      </motion.div>
    );
  };

  return (
    <div
      className="h-screen w-full p-2 flex flex-col gap-2 items-center justify-center fixed top-0 left-0"
      style={{
        backgroundImage: `url('https://media.istockphoto.com/id/1688098382/photo/closeup-of-indian-wedding-couple-holding-hands.jpg?s=612x612&w=0&k=20&c=ROKeVN0SqN4XvFDrriqYFJDOGxwYubyLNglimwRaPlY=')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* <div className="absolute inset-0 grid grid-cols-1 sm:grid-cols-4 gap-0 z-0">
        {[
          "https://media.istockphoto.com/id/529771791/photo/relation-getting-married.jpg?s=612x612&w=0&k=20&c=5_PTNkOUcyGH_fKBsfB8Bw4FSaL81VMzR4aTMkEmqwU=",
          "https://media.istockphoto.com/id/1314780801/photo/traditional-indian-wedding-ceremony-groom-and-bride-hand.jpg?s=612x612&w=0&k=20&c=TVehthRKVLGCvpH4zFul2SvfRhw8UOly3SkqCFOd1FM=",
          "https://media.istockphoto.com/id/638017890/photo/hindu-wedding-ceremony.jpg?s=612x612&w=0&k=20&c=r3Sv2kIVRU6sd7Y8jaBQr0OYlgzo5SzEgziLU05amxQ=",
          "https://media.istockphoto.com/id/154960911/photo/indian-bride-and-groom-with-rings.jpg?s=612x612&w=0&k=20&c=3PgHfQMNR_8ofYBAK2x38Xm75Ev6Gl4vNHP8GpsSfUg=",
        ].map((img, i) => (
          <div
            key={i}
            className="h-full w-full bg-cover bg-center transform transition-transform duration-500 hover:scale-110"
            style={{ backgroundImage: `url(${img})` }}
          />
        ))}
      </div> */}
      {/* Language Dropdown */}
      <div ref={dropdownRef} className="absolute top-4 right-4 z-20">
        <button
          onClick={toggleLanguageDropdown}
          className="bg-white text-[#d35400] p-2 rounded-full font-medium border border-[#f39c12] hover:bg-[#f39c12] hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f39c12] transition-all duration-150 ease-in-out transform hover:scale-[1.02] shadow-md shadow-[#f39c12]/20 hover:shadow-[#f39c12]/30"
        >
          <img src={languageLogo} alt="language-logo" className="h-8 w-8" />
        </button>

        {showLanguageDropdown && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute right-0 mt-2 w-40 bg-white rounded-lg shadow-lg border border-[#f39c12]/20"
          >
            <button
              onClick={() => handleLanguageChange("english")}
              className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-t-lg"
            >
              English
            </button>
            <button
              onClick={() => handleLanguageChange("tamil")}
              className="w-full text-left px-4 py-2 text-[#d35400] hover:bg-[#f39c12] hover:text-white rounded-b-lg"
            >
              தமிழ்
            </button>
          </motion.div>
        )}
      </div>

      {/* Rest of the form */}
      {toast && <Toaster toast={toast} />}

      {previewFile && (
        <FilePreviewModal
          file={previewFile}
          onClose={() => setPreviewFile(null)}
        />
      )}

      {showPopup && (
        <Popup
          open={showPopup}
          onClose={() => setShowPopup(false)}
          position="top center"
          closeOnDocumentClick
        >
          <div className="bg-white p-4 rounded-lg shadow-lg">
            <h3 className="text-lg font-bold mb-2">Form Errors</h3>
            <ul>
              {Object.keys(errors).map((field) => (
                <li key={field} className="text-red-500">
                  {languageData[field] || field}: {errors[field]}
                </li>
              ))}
            </ul>
          </div>
        </Popup>
      )}

      {/* Stepper */}
      <article className=" mx-auto flex">
        <section className="relative w-full sm:w-fit flex items-center gap-6 sm:gap-10 md:gap-20 mt-14 sm:mt-0">
          {[1, 2, 3, 4, 5].map((num) => (
            <div
              key={num}
              className={`${
                step === num
                  ? "bg-[#fa5735] text-white font-medium"
                  : "bg-white border-2 border-[#fa5735] text-black font-medium"
              } rounded-full w-[40px] h-[40px] z-10 flex items-center justify-center`}
            >
              <p className="mt-3.5">{num}</p>
            </div>
          ))}

          {/* Optional: Dotted line background (make sure it's underneath and correctly sized) */}
          <p className="w-full absolute top-1/2 transform -translate-y-1/2 border-t-[4px] border-white border-dashed bg-transparent" />
        </section>
      </article>

      <div className=" mt-4 sm:mt-0 max-w-5xl bg-white p-3 w-full h-auto overflow-y-auto rounded-2xl">
        {/* <div className="w-full bg-gray-200 rounded-full h-2.5 mb-4"> 
      <div className="w-full bg-gray-200 rounded-full h-4 overflow-hidden shadow-lg relative">
      <motion.div
        className="h-full bg-gradient-to-r from-green-400 to-green-600 rounded-full shadow-md"
        initial={{ width: "2%" }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 1, ease: "easeInOut" }}
      ></motion.div>
      <span className="absolute inset-0 flex justify-center items-center text-white text-sm font-semibold">{progress}%</span>
    </div>
    </div> */}
        <div className="bg-gradient-to-r from-red-500 via-amber-400/90 to-red-500/80 z-10 px-4 md:px-8 py-2.5 md:py-2.5 shadow-md rounded-2xl">
          <h2 className="text-2xl md:text-3xl font-bold text-center text-white">
            {languageData?.createAccount || "Find Your Match Today"}
          </h2>
          <p className="text-center text-white text-sm md:text-base">
            {languageData?.joinCommunity ||
              "The Path to Love Start here - Join our Community!"}
          </p>
        </div>

        <div className="px-1 md:px-8 pt-4 md:pt-6 max-h-[calc(100vh-120px)]">
          <AnimatePresence mode="wait">
            <motion.div
              key={step}
              initial={{ opacity: 0, x: step > 1 ? 50 : -50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: step > 1 ? -50 : 50 }}
              transition={{ duration: 0.3 }}
              className="space-y-4"
            >
              {step === 1 && (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <section className="flex flex-col sm:flex-row md:flex-row gap-4 w-full">
                    {/* Profile Image */}
                    <div className="flex flex-col items-center justify-center space-y-6 w-full sm:w-1/3 md:w-1/3 px-2">
                      <div
                        className={`relative w-32 h-32 rounded-full overflow-hidden bg-gray-300 p-1 ${
                          touched.photo && errors.photo
                            ? "ring-1 ring-red-500"
                            : ""
                        }`}
                      >
                        <div className="w-full h-full rounded-full overflow-hidden bg-white">
                          {photoPreview ? (
                            <img
                              src={photoPreview}
                              alt="Profile Preview"
                              className="w-full h-full object-cover"
                            />
                          ) : (
                            <div className="w-full h-full flex items-center justify-center bg-gray-50">
                              <Camera className="w-12 h-12 text-[#fa5735]" />
                            </div>
                          )}
                        </div>
                        <input
                          type="file"
                          id="photo"
                          name="photo"
                          accept="image/*"
                          onChange={(e) => {
                            const value = e.target.value;
                            handleProfilePhotoUpload(e);
                            setTouched((prev) => ({ ...prev, photo: true })); // Mark field as touched
                            if (value) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                photo: "",
                              }));
                              setTouched((prevTouched) => ({
                                ...prevTouched,
                                photo: false,
                              }));
                            }
                          }}
                          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                        />
                      </div>

                      {/* Show error only if touched and has error */}
                      {touched.photo && errors.photo && (
                        <p className="text-red-500 text-sm">{errors.photo}</p>
                      )}

                      <label
                        htmlFor="photo"
                        className="text-[16px] text-white cursor-pointer hover:bg-[#fa6938] transition-all duration-300 px-3 py-2 rounded-xl bg-[#fa6938] font-medium"
                      >
                        {languageData?.uploadPhoto}{" "}
                        <span className="text-white-500">*</span>
                      </label>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 w-full gap-3">
                      {/* Name */}
                      <div>
                        <label className="text-[15px] text-[#676666] font-medium mb-1.5">
                          {languageData?.fullName || "Name"}{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          name="full_name"
                          value={formData.full_name} // Using formData
                          onChange={(e) =>
                            handleInputChange("full_name", e.target.value)
                          }
                          className="w-full px-2 py-2 border-2 rounded-lg text-sm sm:text-base bg-white/70 backdrop-blur-sm"
                          placeholder={
                            languageData?.fullName || "Enter Your Name"
                          }
                          readOnly
                        />
                        {errors.full_name && (
                          <p className="text-red-500 text-sm mt-1">
                            {errors.full_name}
                          </p>
                        )}
                      </div>

                      {/* Matrimony ID */}
                      <div>
                        <label className="text-[15px] text-[#676666] font-medium mb-1.5">
                          {languageData?.matrimonyId}
                        </label>{" "}
                        <span className="text-red-500">*</span>
                        <input
                          type="text"
                          value={formData.matrimony_id}
                          readOnly // Make the matrimony_id field read-only
                          className={`w-full px-2 py-2 border-2 rounded-lg 
                          ${
                            touched.matrimony_id && errors.matrimony_id
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder={languageData?.matrimonyId}
                        />
                        {errors.matrimony_id && touched.matrimony_id && (
                          <p className="text-red-500 text-sm">
                            {errors.matrimony_id}
                          </p>
                        )}
                      </div>

                      {/* Email (Mandatory) */}
                      <div>
                        <label className="text-[15px] text-[#676666] font-medium mb-1.5">
                          {languageData?.email}{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="email"
                          value={formData.email}
                          onChange={(e) =>
                            handleInputChange("email", e.target.value)
                          }
                          className={`w-full px-2 py-2 border-2 rounded-lg 
                          ${
                            touched.email && errors.email
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder="Enter Your Email ID"
                          // {languageData?.email}
                        />
                        {touched.email && errors.email && (
                          <p className="text-red-500 text-sm">
                            {translations[language]?.emailRequired ||
                              "Email is required"}
                          </p>
                        )}
                      </div>

                      {/* Phone Number */}
                      <div>
                        <label className="text-[15px] text-[#676666] font-medium mb-1.5">
                          {languageData?.phoneNumber}{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={formData.phone_number}
                          onChange={(e) =>
                            handleInputChange("phone_number", e.target.value)
                          }
                          className={`w-full px-2 py-2 border-2 rounded-lg 
                          ${
                            touched.phone_number && errors.phone_number
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder="Enter Your Phone Number"
                          readOnly
                        />
                      </div>

                      {/* Password (Mandatory) */}
                      <div>
                        <label className="text-[15px] text-[#676666] font-medium mb-1.5">
                          {languageData?.password}{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                          <input
                            type={showPassword ? "text" : "password"}
                            value={formData.password}
                            onChange={(e) =>
                              handleInputChange("password", e.target.value)
                            }
                            className={`w-full px-2 py-2 border-2 rounded-lg 
                          ${
                            touched.password && errors.password
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                            placeholder={languageData?.password}
                            onBlur={() =>
                              setTouched((prev) => ({
                                ...prev,
                                password: true,
                              }))
                            }
                          />
                          <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-[#e67e22]"
                          >
                            {showPassword ? (
                              <EyeOff className="w-5 h-5" /> // Eye-off icon when visible
                            ) : (
                              <Eye className="w-5 h-5" /> // Eye icon when hidden
                            )}
                          </button>
                        </div>
                        {touched.password && errors.password && (
                          <p className="text-red-500 text-sm">
                            {errors.password}
                          </p>
                        )}
                      </div>

                      {/* Marital Status */}
                      <div>
                        <label className="text-[15px] text-[#676666] font-medium mb-1.5">
                          {languageData?.confirmpassword}{" "}
                        </label>
                        <select
                          value={formData.marital_status}
                          onChange={(e) =>
                            handleInputChange("marital_status", e.target.value)
                          }
                          onBlur={() =>
                            setTouched((prev) => ({
                              ...prev,
                              marital_status: true,
                            }))
                          }
                          className={`w-full px-2 py-2 border-2 rounded-lg
                        ${
                          touched.marital_status && errors.marital_status
                            ? "border-red-500"
                            : "border-gray-300"
                        }
                        focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                        transition-all duration-300 hover:border-[#f39c12]`}
                        >
                          <option value="" disabled>
                            Select Status
                          </option>
                          <option value="Single">Single</option>
                          <option value="Married">Married</option>
                          <option value="Unmarried">Unmarried</option>
                        </select>
                        {touched.marital_status && errors.marital_status && (
                          <p className="text-red-500 text-sm">
                            {errors.marital_status}
                          </p>
                        )}
                      </div>
                    </div>
                  </section>

                  <section className="w-full gap-3">
                    <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-6 w-full gap-3">
                      {/* Date of Birth (Mandatory) */}
                      <div className="w-full">
                        <label className="text-[15px] mb-1.5 font-medium text-[#676666]">
                          {languageData?.dateOfBirth}{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="date"
                          value={formData.date_of_birth}
                          onChange={(e) => {
                            let value = e.target.value;

                            // Validate year length (4 digits)
                            const year = value.split("-")[0]; // Extract the year part
                            if (year.length > 4) {
                              return; // Prevent further input if year exceeds 4 digits
                            }

                            handleInputChange("date_of_birth", value);

                            // Clear error if a valid date is entered
                            if (value) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                date_of_birth: "",
                              }));
                              setTouched((prevTouched) => ({
                                ...prevTouched,
                                date_of_birth: false,
                              }));
                            }
                          }}
                          className={`w-full px-2 py-2 border-2 rounded-lg 
                          ${
                            touched.date_of_birth && errors.date_of_birth
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                        />
                        {touched.date_of_birth && errors.date_of_birth && (
                          <p className="text-red-500 text-sm">
                            {errors.date_of_birth}
                          </p>
                        )}
                      </div>

                      {/* Age (Mandatory) */}
                      <div className="w-full">
                        <label className="text-[15px] mb-1.5 text-[#676666] font-medium">
                          {languageData?.age}{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="number"
                          value={formData.age}
                          onChange={(e) =>
                            handleInputChange("age", e.target.value)
                          }
                          onBlur={() => handleBlur("age")}
                          className="w-full px-2 py-2 border-2 rounded-lg  text-gray-700"
                          placeholder={languageData?.age}
                          readOnly
                        />
                        {touched.age && errors.age && (
                          <p className="text-red-500 text-sm">{errors.age}</p>
                        )}
                      </div>

                      {/* Height */}
                      <div className="w-full">
                        <label className="text-[15px] mb-1.5 font-medium text-[#676666]">
                          {languageData?.height}
                        </label>
                        <input
                          type="text" // Using "text" for full control over input validation
                          value={
                            formData.height === null || formData.height === ""
                              ? ""
                              : formData.height
                          }
                          onChange={(e) => {
                            let value = e.target.value.trim();

                            // Allow empty input (to reset validation)
                            if (value === "") {
                              handleInputChange("height", "");
                              setErrors((prev) => ({ ...prev, height: "" })); // Remove error when empty
                              return;
                            }

                            // Check if it's a valid integer (no decimals) and within 0-250 range
                            if (/^\d+$/.test(value)) {
                              let numValue = parseInt(value, 10);

                              if (numValue >= 0 && numValue <= 250) {
                                handleInputChange("height", value);
                                setErrors((prev) => ({ ...prev, height: "" })); // Remove error when valid
                              } else {
                                setErrors((prev) => ({
                                  ...prev,
                                  height:
                                    language === "english"
                                      ? "Height must be between 0 and 250 cm"
                                      : "உயரம் 0 மற்றும் 250 cm க்கு இடையில் இருக்க வேண்டும்",
                                }));
                              }
                            }
                          }}
                          className={`w-full px-2 py-2 border-2 rounded-lg 
                          ${
                            touched.height && errors.height
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder={languageData?.height}
                        />
                        {touched.height && errors.height && (
                          <p className="text-red-500 text-sm mt-1">
                            {errors.height}
                          </p>
                        )}
                      </div>

                      {/* Weight */}
                      <div className="w-full">
                        <label className="text-[15px] mb-1.5 font-medium text-[#676666]">
                          {languageData?.weight}
                        </label>
                        <input
                          type="text" // Changed to "text" to fully control validation
                          value={
                            formData.weight === null || formData.weight === ""
                              ? ""
                              : formData.weight
                          }
                          onChange={(e) => {
                            let value = e.target.value.trim();

                            // Allow empty input (to reset validation)
                            if (value === "") {
                              handleInputChange("weight", "");
                              setErrors((prev) => ({ ...prev, weight: "" })); // Remove error when empty
                              return;
                            }

                            // Check if it's a valid integer (no decimals) and within 0-150 range
                            if (/^\d+$/.test(value)) {
                              let numValue = parseInt(value, 10);

                              if (numValue >= 0 && numValue <= 150) {
                                handleInputChange("weight", value);
                                setErrors((prev) => ({ ...prev, weight: "" })); // Remove error when valid
                              } else {
                                setErrors((prev) => ({
                                  ...prev,
                                  weight:
                                    language === "english"
                                      ? "Weight must be between 0 and 150 kg"
                                      : "எடை 0 மற்றும் 150 kg க்கு இடையில் இருக்க வேண்டும்",
                                }));
                              }
                            }
                          }}
                          className={`w-full px-2 py-2 border-2 rounded-lg 
                      ${
                        touched.weight && errors.weight
                          ? "border-red-500"
                          : "border-gray-300"
                      }
                      focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                      transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder={languageData?.weight}
                        />
                        {touched.weight && errors.weight && (
                          <p className="text-red-500 text-sm mt-1">
                            {errors.weight}
                          </p>
                        )}
                      </div>

                      {/* Occupation */}
                      <div className="sm:col-span-2 w-full">
                        <label className="text-[15px] mb-1.5 font-medium text-[#676666]">
                          {languageData?.occupation}
                        </label>
                        <input
                          type="text"
                          value={formData.occupation}
                          onChange={(e) =>
                            handleInputChange("occupation", e.target.value)
                          }
                          className={`w-full px-2 py-2 border-2 rounded-lg 
                          ${
                            touched.occupation && errors.occupation
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder={languageData?.occupation}
                        />
                      </div>

                      {/* Gender (Mandatory) */}
                      <div className="w-full">
                        <label className="text-[15px] mb-1.5 font-medium text-[#676666]">
                          {languageData?.selectGender}{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <select
                          value={formData.gender}
                          onChange={(e) =>
                            handleInputChange("gender", e.target.value)
                          }
                          className={`w-full px-2 py-2 border-2 rounded-lg 
                          ${
                            touched.gender && errors.gender
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                        >
                          <option
                            value=""
                            disabled
                            hidden
                            className="text-gray-500"
                          >
                            {languageData?.selectGender}
                          </option>
                          <option value="male">{languageData?.male}</option>
                          <option value="female">{languageData?.female}</option>
                        </select>
                        {touched.gender && errors.gender && (
                          <p className="text-red-500 text-sm">
                            {errors.gender}
                          </p>
                        )}
                      </div>

                      {/* Annual Income */}
                      <div className="sm:col-span-2 w-full">
                        <label className="text-[15px] mb-1.5 font-medium text-[#676666]">
                          {languageData?.annualIncome}
                        </label>
                        <input
                          type="text"
                          value={
                            formData.annual_income === null ||
                            formData.annual_income === ""
                              ? ""
                              : formData.annual_income
                          }
                          onChange={(e) => {
                            let value = e.target.value.trim();
                            if (value === "") {
                              handleInputChange("annual_income", "");
                              setErrors((prev) => ({
                                ...prev,
                                annual_income: "",
                              })); 
                              return;
                            }

                            if (/^\d+$/.test(value)) {
                              if (value.length <= 15) {
                                handleInputChange("annual_income", value);
                                setErrors((prev) => ({
                                  ...prev,
                                  annual_income: "",
                                })); 
                              } else {
                                setErrors((prev) => ({
                                  ...prev,
                                  annual_income:
                                    language === "english"
                                      ? "Annual income cannot exceed 15 digits"
                                      : "ஆண்டு வருமானம் 15 இலக்கங்களை மீறக்கூடாது",
                                }));
                              }
                            } else {
                              setErrors((prev) => ({
                                ...prev,
                                annual_income:
                                  language === "english"
                                    ? "Annual income must be a whole number (no decimals)"
                                    : "ஆண்டு வருமானம் முழு எண்ணாக இருக்க வேண்டும் (தசமங்கள் இல்லை)",
                              }));
                            }
                          }}
                          className={`w-full px-2 py-2 border-2 rounded-lg 
                            ${
                              touched.annual_income && errors.annual_income
                                ? "border-red-500"
                                : "border-gray-300"
                            }
                            focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                            transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder={languageData?.annualIncome}
                        />
                        {touched.annual_income && errors.annual_income && (
                          <p className="text-red-500 text-sm mt-1">
                            {errors.annual_income}
                          </p>
                        )}
                      </div>

                      {/* Blood Group */}
                      <div className="w-full">
                        <label className="text-[15px] mb-1.5 font-medium text-[#676666]">
                          {languageData?.bloodGroup}
                        </label>
                        <select
                          value={formData.blood_group}
                          onChange={(e) =>
                            handleInputChange("blood_group", e.target.value)
                          }
                          className={`w-full px-2 py-2 border-2 rounded-lg 
                          ${
                            touched.blood_group && errors.blood_group
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                        >
                          <option
                            value=""
                            disabled
                            hidden
                            className="text-gray-500"
                          >
                            {languageData?.bloodGroup}
                          </option>
                          <option value="A+">A+</option>
                          <option value="A-">A-</option>
                          <option value="B+">B+</option>
                          <option value="B-">B-</option>
                          <option value="AB+">AB+</option>
                          <option value="AB-">AB-</option>
                          <option value="O+">O+</option>
                          <option value="O-">O-</option>
                        </select>
                      </div>

                      {/* Mother Tongue */}
                      <div className="sm:col-span-2 w-full">
                        <label className="text-[15px] mb-1.5 font-medium text-[#676666]">
                          {languageData?.motherTongue}
                        </label>
                        <input
                          type="text"
                          value={formData.mother_tongue}
                          onChange={(e) =>
                            handleInputChange("mother_tongue", e.target.value)
                          }
                          className={`w-full px-2 py-2 border-2 rounded-lg 
                          ${
                            touched.mother_tongue && errors.mother_tongue
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder={languageData?.motherTongue}
                        />
                      </div>
                    </div>
                  </section>

                  {/* Profile Created By */}
                  {/* <div>
                      <label className="text-sm text-[#676666]">
                        {languageData?.profileCreatedBy}
                      </label>
                      <select
                        value={formData.profile_created_by}
                        onChange={(e) =>
                          handleInputChange(
                            "profile_created_by",
                            e.target.value
                          )
                        }
                        className={`w-full px-2 py-2 border rounded-lg shadow-sm 
                          ${
                            touched.profile_created_by &&
                            errors.profile_created_by
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                      >
                        <option
                          value=""
                          disabled
                          hidden
                          className="text-gray-500"
                        >
                          {languageData?.profileCreatedBy}
                        </option>
                        <option value="Self">Self</option>
                        <option value="Sibling">Sibling</option>
                        <option value="Relative">Relative</option>
                        <option value="Friend">Friend</option>
                      </select>
                    </div> */}

                  {/* Address */}
                  <div>
                    <label className="text-[16px] font-medium text-[#676666] mb-1.5">
                      {languageData?.address}
                    </label>
                    <textarea
                      type="text"
                      value={formData.address}
                      onChange={(e) =>
                        handleInputChange("address", e.target.value)
                      }
                      className={`w-full h-[100px] px-2 py-2 border-2 rounded-lg
                          ${
                            touched.address && errors.address
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                      placeholder="Your Address"
                      // {languageData?.address}
                    />
                  </div>

                  {/* Photo's List Component */}
                  <div className="flex flex-wrap items-center justify-start gap-2 bg-gray-100 rounded-2xl w-full">
                    {renderPhotoFields()}
                  </div>

                  <div className="flex items-center justify-between mt-4 pb-3 sm:pb-0 md:pb-0">
                    {/* Upload Photos (Mandatory) */}
                    {/* Photo Upload Section */}
                    {formData.photos.length < 5 && (
                      <div
                        onClick={addPhotoField}
                        className="flex items-center gap-2 sm:gap-1 px-3 py-2 rounded-2xl bg-[#fa6938] w-fit cursor-pointer"
                      >
                        <button
                          type="button"
                          className="flex items-center justify-center w-8 h-8 sm:w-7 sm:h-7 rounded-lg bg-white/10"
                        >
                          <Plus className="w-4 h-4 text-white" />
                        </button>
                        <label className="text-sm sm:text-xs font-medium text-white cursor-pointer">
                          {languageData?.uploadPhotos || "Upload Photos"}
                        </label>
                      </div>
                    )}

                    {/* Inside the photo upload section (step 1), after the photo upload button */}
                    <div className="flex items-center justify-center w-full mt-2 px-4">
                      <p className="text-sm text-center text-gray-700">
                        {languageData?.loginText || "Already have an account?"}{" "}
                        <Link
                          to="/login"
                          className="inline-block ml-1 text-white bg-[#fa6938] px-3 py-1 rounded-md text-sm font-semibold transition duration-200 hover:bg-[#e75d2f]"
                        >
                          {languageData?.loginButton || "Login"}
                        </Link>
                      </p>
                    </div>

                    <button
                      type="button"
                      onClick={() => {
                        console.log("Next button clicked");
                        handleNextStep();
                      }}
                      className="text-white font-medium px-6 py-2 rounded-2xl bg-[#fa6938] w-fit"
                    >
                      {languageData?.next}
                    </button>
                  </div>
                </form>
              )}

              {step === 2 && (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3">
                    {/* Mother Name */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.motherName}
                      </label>

                      <input
                        type="text"
                        value={formData.mother_name}
                        onChange={(e) =>
                          handleInputChange("mother_name", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg 
                        ${
                          touched.mother_name && errors.mother_name
                            ? "border-red-500"
                            : "border-gray-300"
                        }
                        focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                        transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Mother Name"
                      />
                      {touched.mother_name && errors.mother_name && (
                        <p className="text-red-500 text-sm">
                          {errors.mother_name}
                        </p>
                      )}
                    </div>

                    {/* Father Name */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.fatherName}
                      </label>

                      <input
                        type="text"
                        value={formData.father_name}
                        onChange={(e) =>
                          handleInputChange("father_name", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                        ${
                          touched.father_name && errors.father_name
                            ? "border-red-500"
                            : "border-gray-300"
                        }
                        focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                        transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Father Name"
                      />
                      {touched.father_name && errors.father_name && (
                        <p className="text-red-500 text-sm">
                          {errors.father_name}
                        </p>
                      )}
                    </div>

                    {/* Native */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.native}
                      </label>

                      <input
                        type="text"
                        value={formData.native}
                        onChange={(e) =>
                          handleInputChange("native", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                        ${
                          touched.native && errors.native
                            ? "border-red-500"
                            : "border-gray-300"
                        }
                        focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                        transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Work Native"
                      />
                      {touched.native && errors.native && (
                        <p className="text-red-500 text-sm">{errors.native}</p>
                      )}
                    </div>

                    {/* Mother Occupation */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.motherOccupation}
                      </label>

                      <input
                        type="text"
                        value={formData.mother_occupation}
                        onChange={(e) =>
                          handleInputChange("mother_occupation", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                        ${
                          touched.mother_occupation && errors.mother_occupation
                            ? "border-red-500"
                            : "border-gray-300"
                        }
                        focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                        transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder={languageData?.motherOccupation}
                      />
                      {touched.mother_occupation &&
                        errors.mother_occupation && (
                          <p className="text-red-500 text-sm">
                            {errors.mother_occupation}
                          </p>
                        )}
                    </div>

                    {/* Father Occupation */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.fatherOccupation}
                      </label>
                      <input
                        type="text"
                        value={formData.father_occupation}
                        onChange={(e) =>
                          handleInputChange("father_occupation", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                        ${
                          touched.father_occupation && errors.father_occupation
                            ? "border-red-500"
                            : "border-gray-300"
                        }
                        focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                        transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder={languageData?.fatherOccupation}
                      />
                      {touched.father_occupation &&
                        errors.father_occupation && (
                          <p className="text-red-500 text-sm">
                            {errors.father_occupation}
                          </p>
                        )}
                    </div>

                    {/* Sibling Count */}
                    <div className="w-full">
                      {/* Sibling Count Input */}
                      <div>
                        <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                          {languageData?.siblingCount}
                        </label>
                        <input
                          type="text" 
                          value={
                            formData.sibling_count === ""
                              ? ""
                              : formData.sibling_count
                          }
                          onChange={(e) => {
                            let value = e.target.value.trim();

                            if (value === "") {
                              handleInputChange("sibling_count", "");
                              setErrors((prev) => ({
                                ...prev,
                                sibling_count: "",
                              })); 
                              return;
                            }

                            if (/^\d+$/.test(value)) {
                              let numValue = parseInt(value, 10);

                              if (
                                numValue >= 0 &&
                                numValue <= 15 &&
                                value.length <= 2
                              ) {
                                handleInputChange("sibling_count", value);
                                setErrors((prev) => ({
                                  ...prev,
                                  sibling_count: "",
                                })); // Remove error when valid
                              } else {
                                setErrors((prev) => ({
                                  ...prev,
                                  sibling_count:
                                    language === "english"
                                      ? "Sibling count must be between 0 and 15 and no more than 2 digits"
                                      : "சகோதரர்களின் எண்ணிக்கை 0 மற்றும் 15 க்கு இடையில் இருக்க வேண்டும் மற்றும் 2 இலக்கங்களை மீறக்கூடாது",
                                }));
                              }
                            } else {
                              setErrors((prev) => ({
                                ...prev,
                                sibling_count:
                                  language === "english"
                                    ? "Sibling count must be a whole number (no decimals)"
                                    : "சகோதரர்களின் எண்ணிக்கை முழு எண்ணாக இருக்க வேண்டும் (தசமங்கள் இல்லை)",
                              }));
                            }
                          }}
                          onBlur={() => handleBlur("sibling_count")}
                          className={`w-full px-2 py-2 border-2 rounded-lg
                          ${
                            touched.sibling_count && errors.sibling_count
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder="Sibling Count"
                        />
                        {touched.sibling_count && errors.sibling_count && (
                          <p className="text-red-500 text-sm">
                            {errors.sibling_count}
                          </p>
                        )}
                      </div>

                      {/* Dynamic Sibling Inputs */}
                      {formData.sibling_count > 0 && (
                        <div className="mt-4 space-y-3">
                          {/* Elder Brother */}
                          <Autocomplete
                            multiple
                            freeSolo
                            options={[]}
                            value={Array.isArray(formData.elder_brother) ? formData.elder_brother : []}
                            onChange={(event, value) => {
                              const safeValue = (Array.isArray(value) ? value : [])
                                .filter(item => typeof item === 'string')
                                .map(item => item.replace(/[0-9]/g, ''));
                              handleSiblingChange("elder_brother", safeValue);
                            }}
                            onInputChange={(event, value) => {
                              if (typeof value === 'string' && /\d/.test(value)) {
                                return; 
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={languageData?.elderBrother}
                                placeholder="Type and press enter"
                                InputProps={{
                                  ...params.InputProps,
                                  style: { backgroundColor: "#FFFFFF" },
                                }}
                              />
                            )}
                          />

                          {/* Younger Brother */}
                          <Autocomplete
                            multiple
                            freeSolo
                            options={[]}
                            value={Array.isArray(formData.younger_brother) ? formData.younger_brother : []}
                            onChange={(event, value) => {
                              const safeValue = (Array.isArray(value) ? value : [])
                                .filter(item => typeof item === 'string')
                                .map(item => item.replace(/[0-9]/g, ''));
                              handleSiblingChange("younger_brother", safeValue);
                            }}
                            onInputChange={(event, value) => {
                              if (typeof value === 'string' && /\d/.test(value)) {
                                return;
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={languageData?.youngerBrother}
                                placeholder="Type and press enter"
                                InputProps={{
                                  ...params.InputProps,
                                  style: { backgroundColor: "#FFFFFF" },
                                }}
                              />
                            )}
                          />

                          {/* Elder Sister */}
                          <Autocomplete
                            multiple
                            freeSolo
                            options={[]}
                            value={Array.isArray(formData.elder_sister) ? formData.elder_sister : []}
                            onChange={(event, value) => {
                              const safeValue = (Array.isArray(value) ? value : [])
                                .filter(item => typeof item === 'string')
                                .map(item => item.replace(/[0-9]/g, ''));
                              handleSiblingChange("elder_sister", safeValue);
                            }}
                            onInputChange={(event, value) => {
                              if (typeof value === 'string' && /\d/.test(value)) {
                                return;
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={languageData?.elderSister}
                                placeholder="Type and press enter"
                                InputProps={{
                                  ...params.InputProps,
                                  style: { backgroundColor: "#FFFFFF" },
                                }}
                              />
                            )}
                          />

                          {/* Younger Sister */}
                          <Autocomplete
                            multiple
                            freeSolo
                            options={[]}
                            value={Array.isArray(formData.younger_sister) ? formData.younger_sister : []}
                            onChange={(event, value) => {
                              const safeValue = (Array.isArray(value) ? value : [])
                                .filter(item => typeof item === 'string')
                                .map(item => item.replace(/[0-9]/g, ''));
                              handleSiblingChange("younger_sister", safeValue);
                            }}
                            onInputChange={(event, value) => {
                              if (typeof value === 'string' && /\d/.test(value)) {
                                return;
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={languageData?.youngerSister}
                                placeholder="Type and press enter"
                                InputProps={{
                                  ...params.InputProps,
                                  style: { backgroundColor: "#FFFFFF" },
                                }}
                              />
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex justify-end gap-3 mt-4 pb-3 sm:pb-0">
                    <button
                      type="button"
                      onClick={handlePreviousStep}
                      className="border-2 border-[#575757] text-[#676666] px-6 py-2 rounded-2xl font-medium transition-all duration-300 active:scale-95"
                    >
                      {languageData?.previous}
                    </button>
                    <button
                      type="button"
                      onClick={handleNextStep}
                      className="rounded-2xl bg-[#fa6938] font-medium text-white px-6 py-2 shadow-lg hover:shadow-xl transition-all duration-300 hover:from-[#d35400] hover:to-[#e67e22] active:scale-95"
                    >
                      {languageData?.next}
                    </button>
                  </div>
                </form>
              )}

              {step === 3 && (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-3">
                    {/* Work Type */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.workType}
                      </label>
                      <input
                        type="text"
                        value={formData.work_type}
                        onChange={(e) =>
                          handleInputChange("work_type", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                          ${
                            touched.work_type && errors.work_type
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Work Type"
                      />
                      {touched.work_type && errors.work_type && (
                        <p className="text-red-500 text-sm">
                          {errors.work_type}
                        </p>
                      )}
                    </div>

                    {/* Company Name */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.company}
                      </label>
                      <input
                        type="text"
                        value={formData.company}
                        onChange={(e) =>
                          handleInputChange("company", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                          ${
                            touched.company && errors.company
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Company"
                      />
                      {touched.company && errors.company && (
                        <p className="text-red-500 text-sm">{errors.company}</p>
                      )}
                    </div>

                    {/* Work Location */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.workLocation}
                      </label>
                      <input
                        type="text"
                        value={formData.work_location}
                        onChange={(e) =>
                          handleInputChange("work_location", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg 
                          ${
                            touched.work_location && errors.work_location
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Work Location"
                      />
                      {touched.work_location && errors.work_location && (
                        <p className="text-red-500 text-sm">
                          {errors.work_location}
                        </p>
                      )}
                    </div>

                    {/* Education */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.education}
                      </label>
                      <input
                        type="text"
                        value={formData.education}
                        onChange={(e) =>
                          handleInputChange("education", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                          ${
                            touched.education && errors.education
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Education"
                      />
                      {touched.education && errors.education && (
                        <p className="text-red-500 text-sm">
                          {errors.education}
                        </p>
                      )}
                    </div>

                    {/* Work Country */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.workCountry}
                      </label>
                      <input
                        type="text"
                        value={formData.work_country}
                        onChange={(e) =>
                          handleInputChange("work_country", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                          ${
                            touched.work_country && errors.work_country
                              ? "border-red-500"
                              : "border-gray-300"
                          }
                          focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                          transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Work Country"
                      />
                      {touched.work_country && errors.work_country && (
                        <p className="text-red-500 text-sm">
                          {errors.work_country}
                        </p>
                      )}
                    </div>
                  </div>

                  <div className="flex justify-end gap-3 mt-4 pb-3 sm:pb-0">
                    <button
                      type="button"
                      onClick={handlePreviousStep}
                      className="border-2 border-[#575757] text-[#676666] px-6 py-2 rounded-2xl font-medium transition-all duration-300 active:scale-95"
                    >
                      {languageData?.previous}
                    </button>
                    <button
                      type="button"
                      onClick={handleNextStep}
                      className="rounded-2xl bg-[#fa6938] font-medium text-white px-6 py-2 shadow-lg hover:shadow-xl transition-all duration-300 hover:from-[#d35400] hover:to-[#e67e22] active:scale-95"
                    >
                      {languageData?.next}
                    </button>
                  </div>
                </form>
              )}

              {step === 4 && (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3">
                    {/* Religion */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.religion || "மதம்"}
                      </label>
                      <select
                        value={formData.religion}
                        onChange={(e) =>
                          handleReligionChange("religion", e.target.value)
                        }
                        placeholder={
                          languageData?.religion || "மதத்தைத் தேர்வு செய்யவும்"
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                      ${
                        touched.religion && errors.religion
                          ? "border-red-500"
                          : "border-gray-300"
                      }
                      focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                      transition-all duration-300 hover:border-[#f39c12]`}
                      >
                        <option value="" disabled>
                          {languageData?.religion ||
                            "மதத்தைத் தேர்வு செய்யவும்"}
                        </option>
                        <option value="Hindu">
                          {languageData?.hindu || "இந்து"}
                        </option>
                        <option value="Muslim">
                          {languageData?.muslim || "முச்லிம்"}
                        </option>
                        <option value="Christian">
                          {languageData?.christian || "கிறிஸ்தவர்"}
                        </option>
                      </select>
                      {touched.religion && errors.religion && (
                        <p className="text-red-500 text-sm">
                          {errors.religion}
                        </p>
                      )}
                    </div>

                    {/* Caste */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.caste || "சாதி"}
                      </label>
                      <div className="w-full">
                        <select
                          value={formData.caste}
                          onChange={(e) => handleCasteChange(e.target.value)}
                          className="w-full px-2 py-2 border-2 rounded-lg border-gray-300 
                        focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                        transition-all duration-300 hover:border-[#f39c12]"
                          disabled={!formData.religion} // Disable if no religion is selected
                        >
                          <option value="" disabled>
                            {languageData?.castes}
                          </option>

                          {formData.religion === "Hindu" && (
                            <optgroup
                              label={language === "tamil" ? "இந்து" : "Hindu"}
                            >
                              {casteOptions.map((caste) => (
                                <option key={caste.value} value={caste.value}>
                                  {language === "tamil"
                                    ? caste.tamil
                                    : caste.english}
                                </option>
                              ))}
                            </optgroup>
                          )}

                          {formData.religion === "Muslim" && (
                            <optgroup
                              label={
                                language === "tamil" ? "முஸ்லிம்" : "Muslim"
                              }
                            >
                              {muslimCasteOptions.map((caste) => (
                                <option key={caste.value} value={caste.value}>
                                  {language === "tamil"
                                    ? caste.tamil
                                    : caste.english}
                                </option>
                              ))}
                            </optgroup>
                          )}

                          {formData.religion === "Christian" && (
                            <optgroup
                              label={
                                language === "tamil"
                                  ? "கிறிஸ்தவர்"
                                  : "Christian"
                              }
                            >
                              {christianCasteOptions.map((caste) => (
                                <option key={caste.value} value={caste.value}>
                                  {language === "tamil"
                                    ? caste.tamil
                                    : caste.english}
                                </option>
                              ))}
                            </optgroup>
                          )}
                        </select>
                      </div>
                    </div>

                    {/* Sub Caste */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.subCaste || "SubCaste / உட்பிரிவு"}
                      </label>
                      <input
                        type="text"
                        value={formData.sub_caste}
                        onChange={(e) =>
                          handleInputChange("sub_caste", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                      ${
                        touched.sub_caste && errors.sub_caste
                          ? "border-red-500"
                          : "border-gray-300"
                      }
                      focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                      transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder={
                          languageData?.placeholders ||
                          "Enter SubCaste / உட்பிரிவு உள்ளிடவும்"
                        }
                      />
                      {touched.sub_caste && errors.sub_caste && (
                        <p className="text-red-500 text-sm">
                          {errors.sub_caste}
                        </p>
                      )}
                    </div>

                    {/* Nakshatra */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.nakshatra}
                      </label>
                      <select
                        value={formData.nakshatra}
                        onChange={(e) =>
                          handleInputChange("nakshatra", e.target.value)
                        }
                        className="w-full px-2 py-2 border-2 rounded-lg border-gray-300 focus:ring-[#e67e22] focus:border-[#e67e22] bg-white transition-all duration-300 hover:border-[#f39c12]"
                      >
                        <option
                          value=""
                          disabled
                          hidden
                          className="text-gray-500"
                        >
                          {languageData?.nakshatra}
                        </option>
                        {nakshatras.map((nakshatra) => (
                          <option key={nakshatra} value={nakshatra}>
                            {nakshatra}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* quarter */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.quarter}
                      </label>
                      <select
                        value={formData.quarter}
                        onChange={(e) =>
                          handleInputChange("quarter ", e.target.value)
                        }
                        className="w-full px-2 py-2 border-2 rounded-lg border-gray-300 focus:ring-[#e67e22] focus:border-[#e67e22] bg-white transition-all duration-300 hover:border-[#f39c12]"
                      >
                        <option
                          value=""
                          disabled
                          hidden
                          className="text-gray-500"
                        >
                          {languageData?.quarter}
                        </option>
                        {quarters.map((quarter) => (
                          <option key={quarter} value={quarter}>
                            {quarter}
                          </option>
                        ))}
                        {/* {quarters.map((quarter) => (
                      <option key={quarter.value} value={quarter.value}>
                        {quarter.label}
                      </option>
                    ))} */}
                      </select>
                    </div>

                    {/* Rashi Display (Read-Only) */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.rashi || "Rashi"}
                      </label>
                      <input
                        type="text"
                        value={formData.rashi}
                        className={`w-full px-2 py-2 border-2 rounded-lg ${
                          touched.rashi && errors.rashi
                            ? "border-red-500"
                            : "border-gray-300"
                        } focus:ring-[#e67e22] focus:border-[#e67e22] bg-white transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Rashi"
                        readOnly
                      />
                    </div>

                    {/* Birth Time */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.birthTime}
                      </label>
                      <input
                        type="time"
                        value={formData.birth_time}
                        onChange={(e) =>
                          handleInputChange("birth_time", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                        ${
                          touched.birth_time && errors.birth_time
                            ? "border-red-500"
                            : "border-gray-300"
                        }
                        focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                        transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Birth Time"
                      />
                      {touched.birth_time && errors.birth_time && (
                        <p className="text-red-500 text-sm">
                          {errors.birth_time}
                        </p>
                      )}
                    </div>

                    {/* Birth Place */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.birthPlace}
                      </label>
                      <input
                        type="text"
                        value={formData.birth_place}
                        onChange={(e) =>
                          handleInputChange("birth_place", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg
                        ${
                          touched.birth_place && errors.birth_place
                            ? "border-red-500"
                            : "border-gray-300"
                        }
                        focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                        transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Birth Place"
                      />
                      {touched.birth_place && errors.birth_place && (
                        <p className="text-red-500 text-sm">
                          {errors.birth_place}
                        </p>
                      )}
                    </div>

                    {/* Ascendent */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.ascendent}
                      </label>
                      <input
                        type="text"
                        value={formData.ascendent}
                        onChange={(e) =>
                          handleInputChange("ascendent", e.target.value)
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg 
                        ${
                          touched.ascendent && errors.ascendent
                            ? "border-red-500"
                            : "border-gray-300"
                        }
                        focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                        transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder="Enter Your Ascendent"
                      />
                      {touched.ascendent && errors.ascendent && (
                        <p className="text-red-500 text-sm">
                          {errors.ascendent}
                        </p>
                      )}
                    </div>

                    {/* Dosham */}
                    <div className="w-full">
                      <div className="flex flex-col">
                        <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                          {languageData?.dosham || "Dosham"}
                        </label>
                        <select
                          name="dosham"
                          value={formData.dhosham} // ✅ Ensure it's "dosham" consistently
                          onChange={(e) =>
                            handleInputChange("dhosham", e.target.value)
                          }
                          className="w-full px-2 py-2 border-2 border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-500 transition"
                        >
                          <option value="" disabled>
                            {languageData?.select || "Select"}
                          </option>
                          <option value="putthira_dosham">
                            {languageData?.putthira_dosham}
                          </option>
                          <option value="naaga_dosham">
                            {languageData?.naaga_dosham}
                          </option>
                          <option value="sevvai_dosham">
                            {languageData?.sevvai_dosham}
                          </option>
                          <option value="rahu_chandra_grahana_dosham">
                            {languageData?.rahu_chandra_grahana_dosham}
                          </option>
                          <option value="kaala_sarpa_dosham">
                            {languageData?.kaala_sarpa_dosham}
                          </option>
                          <option value="mangala_dosham">
                            {languageData?.mangala_dosham}
                          </option>
                          <option value="naadi_dosham">
                            {languageData?.naadi_dosham}
                          </option>
                          <option value="other">
                            {languageData?.other || "Other"}
                          </option>
                        </select>
                      </div>

                      {/* Conditionally render input for "other" selection */}
                      {formData.dhosham === "other" && (
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3 }}
                          className="flex flex-col mt-4"
                        >
                          <label className="text-gray-600 text-sm">
                            {languageData?.specifyLabel || "Please specify"}
                          </label>
                          <input
                            type="text"
                            name="other_dosham"
                            value={formData.other_dhosham || ""} // ✅ Ensure it's "other_dosham" consistently
                            onChange={(e) =>
                              handleInputChange("other_dhosham", e.target.value)
                            }
                            className="w-full p-2 border border-gray-300 rounded-md text-gray-700 focus:outline-none focus:ring-2 focus:ring-purple-500 transition"
                            placeholder={
                              languageData?.specifyPlaceholder ||
                              "Enter details"
                            }
                          />
                        </motion.div>
                      )}
                    </div>
                  </div>

                  {/* Horoscope documents List Component */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 bg-gray-100 rounded-2xl">
                    {renderHoroscopeFields()}
                  </div>

                  {/* Horoscope Prev & Next Button */}
                  <div className="flex flex-col sm:flex-row sm:justify-between mt-4 pb-3 sm:pb-0 md:pb-0">
                    <div>
                      {formData.horoscope_documents.length < 5 && (
                        <div
                          onClick={addHoroscopeField}
                          className="flex justify-center items-center bg-[#fa6938] pr-3 py-2 rounded-2xl mt-4 cursor-pointer"
                        >
                          <div className="flex flex-wrap gap-2">
                            <button
                              type="button"
                              className="flex items-center justify-center w-10 h-10 rounded-lg cursor-pointer"
                            >
                              <Plus className="w-5 h-5 text-white" />
                            </button>
                          </div>

                          <label className="text-[15px] font-medium text-white mb-1.5 mt-1 cursor-pointer">
                            {languageData?.horoscopeDocuments}
                          </label>
                        </div>
                      )}
                    </div>

                    <div className="flex items-center justify-end gap-2 mt-4 sm:mt-0">
                      <button
                        type="button"
                        onClick={handlePreviousStep}
                        className="border-2 border-[#575757] text-[#676666] px-6 py-2 rounded-2xl font-medium transition-all duration-300 active:scale-95"
                      >
                        {languageData?.previous}
                      </button>
                      <button
                        type="button"
                        onClick={handleNextStep}
                        className="rounded-2xl bg-[#fa6938] font-medium text-white px-6 py-2.5 shadow-lg hover:shadow-xl transition-all duration-300 hover:from-[#d35400] hover:to-[#e67e22] active:scale-95"
                      >
                        {languageData?.next}
                      </button>
                    </div>
                  </div>
                </form>
              )}

              {step === 5 && (
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-3">
                    {/* <h3 className="text-sm text-center text-gray-600 w-full">
                      {languageData?.PartnerPreferences}
                    </h3> */}

                    {/* Age Range */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.ageRange}
                      </label>
                      <div className="flex space-x-4">
                        {/* Min Age Input */}
                        <input
                          type="text" // Using "text" for full control over input validation
                          value={
                            formData.preferred_age_min === null ||
                            formData.preferred_age_min === ""
                              ? ""
                              : formData.preferred_age_min
                          }
                          onChange={(e) => {
                            let value = e.target.value.trim();
                            // Allow only numeric input
                            if (/^\d*$/.test(value)) {
                              handleInputChange("preferred_age_min", value);
                            }
                          }}
                          onBlur={(e) => {
                            let value = e.target.value.trim();

                            // Validate on blur
                            if (value === "") {
                              setErrors((prev) => ({
                                ...prev,
                                preferred_age_min: "",
                              })); // Remove error when empty
                            } else {
                              let numValue = parseInt(value, 10);
                              if (isNaN(numValue)) {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_age_min:
                                    language === "english"
                                      ? "Age must be a valid number"
                                      : "வயது சரியான எண்ணாக இருக்க வேண்டும்",
                                }));
                              } else if (numValue < 21 || numValue > 75) {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_age_min:
                                    language === "english"
                                      ? "Minimum age must be between 21 and 75"
                                      : "குறைந்தபட்ச வயது 21 மற்றும் 75 க்கு இடையில் இருக்க வேண்டும்",
                                }));
                              } else {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_age_min: "",
                                })); // Remove error when valid
                              }
                            }
                          }}
                          className={`w-1/2 px-2 py-2 border-2 rounded-lg
                    ${
                      touched.preferred_age_min && errors.preferred_age_min
                        ? "border-red-500"
                        : "border-gray-300"
                    }
                    focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                    transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder={languageData?.minAge}
                        />

                        {/* Max Age Input */}
                        <input
                          type="text" // Using "text" for full control over input validation
                          value={
                            formData.preferred_age_max === null ||
                            formData.preferred_age_max === ""
                              ? ""
                              : formData.preferred_age_max
                          }
                          onChange={(e) => {
                            let value = e.target.value.trim();
                            // Allow only numeric input
                            if (/^\d*$/.test(value)) {
                              handleInputChange("preferred_age_max", value);
                            }
                          }}
                          onBlur={(e) => {
                            let value = e.target.value.trim();

                            // Validate on blur
                            if (value === "") {
                              setErrors((prev) => ({
                                ...prev,
                                preferred_age_max: "",
                              })); // Remove error when empty
                            } else {
                              let numValue = parseInt(value, 10);
                              if (isNaN(numValue)) {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_age_max:
                                    language === "english"
                                      ? "Age must be a valid number"
                                      : "வயது சரியான எண்ணாக இருக்க வேண்டும்",
                                }));
                              } else if (numValue < 21 || numValue > 75) {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_age_max:
                                    language === "english"
                                      ? "Maximum age must be between 21 and 75"
                                      : "அதிகபட்ச வயது 21 மற்றும் 75 க்கு இடையில் இருக்க வேண்டும்",
                                }));
                              } else if (
                                formData.preferred_age_min &&
                                numValue <
                                  parseInt(formData.preferred_age_min, 10)
                              ) {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_age_max:
                                    language === "english"
                                      ? "Maximum age cannot be less than minimum age"
                                      : "அதிகபட்ச வயது குறைந்தபட்ச வயதை விட குறைவாக இருக்கக்கூடாது",
                                }));
                              } else {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_age_max: "",
                                })); // Remove error when valid
                              }
                            }
                          }}
                          className={`w-1/2 px-2 py-2 border-2 rounded-lg 
                    ${
                      touched.preferred_age_max && errors.preferred_age_max
                        ? "border-red-500"
                        : "border-gray-300"
                    }
                    focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                    transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder={languageData?.maxAge}
                        />
                      </div>
                      {/* Error Messages for Age Range */}
                      {touched.preferred_age_min &&
                        errors.preferred_age_min && (
                          <p className="text-red-500 text-sm mt-1">
                            {errors.preferred_age_min}
                          </p>
                        )}
                      {touched.preferred_age_max &&
                        errors.preferred_age_max && (
                          <p className="text-red-500 text-sm mt-1">
                            {errors.preferred_age_max}
                          </p>
                        )}
                    </div>

                    {/* Height Range */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.heightRange}
                      </label>
                      <div className="flex space-x-4">
                        {/* Min Height Input */}
                        <input
                          type="text" // Using "text" for full control over input validation
                          value={
                            formData.preferred_height_min === null ||
                            formData.preferred_height_min === ""
                              ? ""
                              : formData.preferred_height_min
                          }
                          onChange={(e) => {
                            let value = e.target.value.trim();
                            // Allow only numeric input
                            if (/^\d*$/.test(value)) {
                              handleInputChange("preferred_height_min", value);
                            }
                          }}
                          onBlur={(e) => {
                            let value = e.target.value.trim();

                            // Validate on blur
                            if (value === "") {
                              setErrors((prev) => ({
                                ...prev,
                                preferred_height_min: "",
                              })); // Remove error when empty
                            } else {
                              let numValue = parseInt(value, 10);
                              if (isNaN(numValue)) {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_height_min:
                                    language === "english"
                                      ? "Height must be a valid number"
                                      : "உயரம் சரியான எண்ணாக இருக்க வேண்டும்",
                                }));
                              } else if (numValue < 50 || numValue > 250) {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_height_min:
                                    language === "english"
                                      ? "Minimum height must be between 50 and 250 cm"
                                      : "குறைந்தபட்ச உயரம் 50 மற்றும் 250 cm க்கு இடையில் இருக்க வேண்டும்",
                                }));
                              } else {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_height_min: "",
                                })); // Remove error when valid
                              }
                            }
                          }}
                          className={`w-1/2 px-2 py-2 border-2 rounded-lg
                    ${
                      touched.preferred_height_min &&
                      errors.preferred_height_min
                        ? "border-red-500"
                        : "border-gray-300"
                    }
                    focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                    transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder={languageData?.minHeight}
                        />
                        {/* Max Height Input */}
                        <input
                          type="text" // Using "text" for full control over input validation
                          value={
                            formData.preferred_height_max === null ||
                            formData.preferred_height_max === ""
                              ? ""
                              : formData.preferred_height_max
                          }
                          onChange={(e) => {
                            let value = e.target.value.trim();
                            // Allow only numeric input
                            if (/^\d*$/.test(value)) {
                              handleInputChange("preferred_height_max", value);
                            }
                          }}
                          onBlur={(e) => {
                            let value = e.target.value.trim();

                            // Validate on blur
                            if (value === "") {
                              setErrors((prev) => ({
                                ...prev,
                                preferred_height_max: "",
                              })); // Remove error when empty
                            } else {
                              let numValue = parseInt(value, 10);
                              if (isNaN(numValue)) {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_height_max:
                                    language === "english"
                                      ? "Height must be a valid number"
                                      : "உயரம் சரியான எண்ணாக இருக்க வேண்டும்",
                                }));
                              } else if (numValue < 50 || numValue > 250) {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_height_max:
                                    language === "english"
                                      ? "Maximum height must be between 50 and 250 cm"
                                      : "அதிகபட்ச உயரம் 50 மற்றும் 250 cm க்கு இடையில் இருக்க வேண்டும்",
                                }));
                              } else if (
                                formData.preferred_height_min &&
                                numValue <
                                  parseInt(formData.preferred_height_min, 10)
                              ) {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_height_max:
                                    language === "english"
                                      ? "Maximum height cannot be less than minimum height"
                                      : "அதிகபட்ச உயரம் குறைந்தபட்ச உயரத்தை விட குறைவாக இருக்கக்கூடாது",
                                }));
                              } else {
                                setErrors((prev) => ({
                                  ...prev,
                                  preferred_height_max: "",
                                })); // Remove error when valid
                              }
                            }
                          }}
                          className={`w-1/2 px-2 py-2 border-2 rounded-lg
                    ${
                      touched.preferred_height_max &&
                      errors.preferred_height_max
                        ? "border-red-500"
                        : "border-gray-300"
                    }
                    focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
                    transition-all duration-300 hover:border-[#f39c12]`}
                          placeholder={languageData?.maxHeight}
                        />
                      </div>
                      {/* Error Messages for Height Range */}
                      {touched.preferred_height_min &&
                        errors.preferred_height_min && (
                          <p className="text-red-500 text-sm mt-1">
                            {errors.preferred_height_min}
                          </p>
                        )}
                      {touched.preferred_height_max &&
                        errors.preferred_height_max && (
                          <p className="text-red-500 text-sm mt-1">
                            {errors.preferred_height_max}
                          </p>
                        )}
                    </div>

                    {/* Religion */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.religion || "மதம்"}
                      </label>

                      {/* Yes / No Radio Selection */}
                      <div className="flex space-x-4">
                        <label
                          className={`px-3 py-2 rounded-2xl text-sm font-semibold cursor-pointer border transition 
                            ${
                              formData.isReligionRequired === "yes"
                                ? "bg-[#fa6938] text-white border-[#fa6938]"
                                : "border-2 border-[#fa6938] text-[#676767] bg-white"
                            }`}
                        >
                          <input
                            type="radio"
                            name="isReligionRequired"
                            value="yes"
                            checked={formData.isReligionRequired === "yes"}
                            onChange={() =>
                              handleInputChange("isReligionRequired", "yes")
                            }
                            className="hidden"
                          />
                          {languageData?.yes || "Yes"}
                        </label>

                        <label
                          className={`px-3 py-2 rounded-2xl text-sm font-semibold cursor-pointer border transition 
                            ${
                              formData.isReligionRequired === "no"
                                ? "bg-[#fa6938] text-white border-[#fa6938]"
                                : "border-2 border-[#fa6938] text-[#676767] bg-white"
                            }`}
                        >
                          <input
                            type="radio"
                            name="isReligionRequired"
                            value="no"
                            checked={formData.isReligionRequired === "no"}
                            onChange={() =>
                              handleInputChange("isReligionRequired", "no")
                            }
                            className="hidden"
                          />
                          {languageData?.no || "No"}
                        </label>
                      </div>

                      {/* Religion Selection (Only if "Yes" is Selected) */}
                      {formData.isReligionRequired === "yes" && (
                        <div className="flex flex-col space-y-2 mt-2">
                          {["Hindu", "Muslim", "Christian"].map((religion) => (
                            <div key={religion} className="flex items-center">
                              <input
                                type="checkbox"
                                id={religion.toLowerCase()}
                                name="religion"
                                value={religion}
                                checked={formData.preferred_religion.includes(
                                  religion,
                                )}
                                onChange={(e) =>
                                  handleReligionChanges(
                                    e.target.checked,
                                    religion,
                                  )
                                }
                                className="w-4 h-4 border-gray-300 text-[#e67e22] focus:ring-[#e67e22]"
                              />
                              <label
                                htmlFor={religion.toLowerCase()}
                                className="ml-2 text-sm text-[#676666]"
                              >
                                {languageData?.[religion.toLowerCase()] ||
                                  religion}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* Validation Errors */}
                      {touched.religion && errors.religion && (
                        <p className="text-red-500 text-sm mt-1">
                          {errors.religion}
                        </p>
                      )}
                    </div>

                    {/* Caste */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.caste || "Caste"}
                      </label>

                      <div className="flex space-x-4">
                        {/* Yes Option */}
                        <label
                          className={`px-3 py-2 rounded-2xl text-sm font-semibold cursor-pointer border transition
                              ${
                                Array.isArray(formData.preferred_caste)
                                  ? "bg-[#fa6938] text-white border-[#fa6938]"
                                  : "border-2 border-[#fa6938] text-[#676767] bg-white"
                              }`}
                        >
                          <input
                            type="radio"
                            name="casteRequired"
                            value="yes"
                            checked={Array.isArray(formData.preferred_caste)}
                            onChange={() =>
                              handleInputChange("preferred_caste", [])
                            }
                            className="hidden"
                          />
                          {languageData?.yes || "Yes"}
                        </label>

                        {/* No Option */}
                        <label
                          className={`px-3 py-2 rounded-2xl text-sm font-semibold cursor-pointer border transition
                              ${
                                formData.preferred_caste === "no"
                                  ? "bg-[#fa6938] text-white border-[#fa6938]"
                                  : "border-2 border-[#fa6938] text-[#676767] bg-white"
                              }`}
                        >
                          <input
                            type="radio"
                            name="casteRequired"
                            value="no"
                            checked={formData.preferred_caste === "no"}
                            onChange={() =>
                              handleInputChange("preferred_caste", "no")
                            }
                            className="hidden"
                          />
                          {languageData?.no || "No"}
                        </label>
                      </div>

                      {formData.preferred_caste &&
                        Array.isArray(formData.preferred_caste) && (
                          <div className="grid grid-cols-2 space-y-2 mt-4">
                            {/* Show Hindu Caste Options if Hindu is selected */}
                            {formData.preferred_religion.includes("Hindu") &&
                              casteOptions.map((caste) => (
                                <div
                                  key={caste.value}
                                  className="flex items-center"
                                >
                                  <input
                                    type="checkbox"
                                    id={`caste-${caste.value}`}
                                    value={caste.value}
                                    checked={formData.preferred_caste?.includes(
                                      caste.value,
                                    )}
                                    onChange={(e) => {
                                      const updatedCastes = e.target.checked
                                        ? [
                                            ...(formData.preferred_caste || []),
                                            caste.value,
                                          ]
                                        : (
                                            formData.preferred_caste || []
                                          ).filter(
                                            (item) => item !== caste.value,
                                          );
                                      handleInputChange(
                                        "preferred_caste",
                                        updatedCastes,
                                      );
                                    }}
                                    className="w-4 h-4 text-[#e67e22] border-gray-300 rounded"
                                  />
                                  <label
                                    htmlFor={`caste-${caste.value}`}
                                    className="ml-2 text-[#676666] text-sm"
                                  >
                                    {language === "tamil"
                                      ? caste.tamil
                                      : caste.english}
                                  </label>
                                </div>
                              ))}

                            {/* Show Muslim Caste Options if Muslim is selected */}
                            {formData.preferred_religion.includes("Muslim") &&
                              muslimCasteOptions.map((caste) => (
                                <div
                                  key={caste.value}
                                  className="flex items-center"
                                >
                                  <input
                                    type="checkbox"
                                    id={`caste-${caste.value}`}
                                    value={caste.value}
                                    checked={formData.preferred_caste?.includes(
                                      caste.value,
                                    )}
                                    onChange={(e) => {
                                      const updatedCastes = e.target.checked
                                        ? [
                                            ...(formData.preferred_caste || []),
                                            caste.value,
                                          ]
                                        : (
                                            formData.preferred_caste || []
                                          ).filter(
                                            (item) => item !== caste.value,
                                          );
                                      handleInputChange(
                                        "preferred_caste",
                                        updatedCastes,
                                      );
                                    }}
                                    className="w-4 h-4 text-[#e67e22] border-gray-300 rounded"
                                  />
                                  <label
                                    htmlFor={`caste-${caste.value}`}
                                    className="ml-2 text-[#676666] text-sm"
                                  >
                                    {language === "tamil"
                                      ? caste.tamil
                                      : caste.english}
                                  </label>
                                </div>
                              ))}

                            {/* Show Christian Caste Options if Christian is selected */}
                            {formData.preferred_religion.includes(
                              "Christian",
                            ) &&
                              christianCasteOptions.map((caste) => (
                                <div
                                  key={caste.value}
                                  className="flex items-center"
                                >
                                  <input
                                    type="checkbox"
                                    id={`caste-${caste.value}`}
                                    value={caste.value}
                                    checked={formData.preferred_caste?.includes(
                                      caste.value,
                                    )}
                                    onChange={(e) => {
                                      const updatedCastes = e.target.checked
                                        ? [
                                            ...(formData.preferred_caste || []),
                                            caste.value,
                                          ]
                                        : (
                                            formData.preferred_caste || []
                                          ).filter(
                                            (item) => item !== caste.value,
                                          );
                                      handleInputChange(
                                        "preferred_caste",
                                        updatedCastes,
                                      );
                                    }}
                                    className="w-4 h-4 text-[#e67e22] border-gray-300 rounded"
                                  />
                                  <label
                                    htmlFor={`caste-${caste.value}`}
                                    className="ml-2 text-[#676666] text-sm"
                                  >
                                    {language === "tamil"
                                      ? caste.tamil
                                      : caste.english}
                                  </label>
                                </div>
                              ))}
                          </div>
                        )}

                      {touched.preferred_caste && errors.preferred_caste && (
                        <p className="text-red-500 text-sm">
                          {errors.preferred_caste}
                        </p>
                      )}
                    </div>

                    {/* Nakshatra */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.nakshatra}
                      </label>

                      <div className="flex space-x-4">
                        {/* Yes Option */}
                        <label
                          className={`px-3 py-2 rounded-2xl text-sm font-semibold cursor-pointer border transition
                            ${
                              formData.isNakshatraRequired === "yes"
                                ? "bg-[#fa6938] text-white border-[#fa6938]"
                                : "border-2 border-[#fa6938] text-[#676767] bg-white"
                            }`}
                        >
                          <input
                            type="radio"
                            name="isNakshatraRequired"
                            value="yes"
                            checked={formData.isNakshatraRequired === "yes"}
                            onChange={() =>
                              handleInputChange("isNakshatraRequired", "yes")
                            }
                            className="hidden"
                          />
                          {languageData?.yes || "Yes"}
                        </label>

                        {/* No Option */}
                        <label
                          className={`px-3 py-2 rounded-2xl text-sm font-semibold cursor-pointer border transition
                            ${
                              formData.isNakshatraRequired === "no"
                                ? "bg-[#fa6938] text-white border-[#fa6938]"
                                : "border-2 border-[#fa6938] text-[#676767] bg-white"
                            }`}
                        >
                          <input
                            type="radio"
                            name="isNakshatraRequired"
                            value="no"
                            checked={formData.isNakshatraRequired === "no"}
                            onChange={() =>
                              handleInputChange("isNakshatraRequired", "no")
                            }
                            className="hidden"
                          />
                          {languageData?.no || "No"}
                        </label>
                      </div>

                      {formData.isNakshatraRequired === "yes" && (
                        <div className="grid grid-cols-2 space-y-2 mt-4">
                          {nakshatras.map((nakshatra) => (
                            <label
                              key={nakshatra}
                              className="flex items-center"
                            >
                              <input
                                type="checkbox"
                                value={nakshatra}
                                checked={formData.preferred_nakshatra.includes(
                                  nakshatra,
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    "preferred_nakshatra",
                                    nakshatra,
                                    e.target.checked,
                                  )
                                }
                                className="w-4 h-4 border-gray-300 text-[#e67e22]"
                              />
                              <span className="ml-2 text-sm text-gray-600">
                                {nakshatra}
                              </span>
                            </label>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Rashi */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.rashi || "Rashi"}
                      </label>

                      <div className="flex space-x-4">
                        {/* Yes Option */}
                        <label
                          className={`px-3 py-2 rounded-2xl text-sm font-semibold cursor-pointer border transition
                            ${
                              formData.isRashiRequired === "yes"
                                ? "bg-[#fa6938] text-white border-[#fa6938]"
                                : "border-2 border-[#fa6938] text-[#676767] bg-white"
                            }`}
                        >
                          <input
                            type="radio"
                            name="isRashiRequired"
                            value="yes"
                            checked={formData.isRashiRequired === "yes"}
                            onChange={() =>
                              handleInputChange("isRashiRequired", "yes")
                            }
                            className="hidden"
                          />
                          {languageData?.yes || "Yes"}
                        </label>

                        {/* No Option */}
                        <label
                          className={`px-3 py-2 rounded-2xl text-sm font-semibold cursor-pointer border transition
                            ${
                              formData.isRashiRequired === "no"
                                ? "bg-[#fa6938] text-white border-[#fa6938]"
                                : "border-2 border-[#fa6938] text-[#676767] bg-white"
                            }`}
                        >
                          <input
                            type="radio"
                            name="isRashiRequired"
                            value="no"
                            checked={formData.isRashiRequired === "no"}
                            onChange={() =>
                              handleInputChange("isRashiRequired", "no")
                            }
                            className="hidden"
                          />
                          {languageData?.no || "No"}
                        </label>
                      </div>

                      {formData.isRashiRequired === "yes" && (
                        <div className="grid grid-cols-2 space-y-2 mt-4">
                          {rashiOptions.map((rashi) => (
                            <label
                              key={rashi.value}
                              className="flex items-center"
                            >
                              <input
                                type="checkbox"
                                value={rashi.value}
                                checked={formData.preferred_rashi.includes(
                                  rashi.value,
                                )}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    "preferred_rashi",
                                    rashi.value,
                                    e.target.checked,
                                  )
                                }
                                className="w-4 h-4 border-gray-300 text-[#e67e22]"
                              />
                              <span className="ml-2 text-sm text-gray-600">
                                {language === "tamil"
                                  ? rashi.label.ta
                                  : rashi.label.en}
                              </span>
                            </label>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Working Status */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.workingStatus || "வேலை நிலை"}
                      </label>

                      <select
                        name="preferred_work_status"
                        value={formData.preferred_work_status}
                        onChange={(e) => {
                          const value = e.target.value;
                          handleInputChange("preferred_work_status", value);

                          // Clear sub_caste when working status is selected
                          if (value) {
                            handleInputChange("sub_caste", "");
                          }
                        }}
                        className={`w-full px-2 py-2 border-2 rounded-lg transition-all duration-300 
                focus:ring-[#e67e22] focus:border-[#e67e22] bg-white 
                hover:border-[#f39c12]
                ${
                  touched.preferred_work_status && errors.preferred_work_status
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                      >
                        <option value="" disabled>
                          {languageData?.selectStatus ||
                            "நிலை தேர்ந்தெடுக்கவும்"}
                        </option>
                        <option value="Working">
                          {languageData?.working || "வேலை செய்யும்"}
                        </option>
                        <option value="Not Working">
                          {languageData?.notWorking || "வேலை செய்யவில்லை"}
                        </option>
                      </select>

                      {/* Display error message */}
                      {touched.preferred_work_status &&
                        errors.preferred_work_status && (
                          <p className="text-red-500 text-sm">
                            {errors.preferred_work_status}
                          </p>
                        )}
                    </div>

                    {/* Preferred Location */}
                    <div className="w-full">
                      <label className="text-[15px] font-medium text-[#676666] mb-1.5">
                        {languageData?.preferredLocation}
                      </label>
                      <input
                        type="text"
                        value={formData.preferred_location}
                        onChange={(e) =>
                          handleInputChange(
                            "preferred_location",
                            e.target.value,
                          )
                        }
                        className={`w-full px-2 py-2 border-2 rounded-lg 
              ${
                touched.preferred_location && errors.preferred_location
                  ? "border-red-500"
                  : "border-gray-300"
              }
              focus:ring-[#e67e22] focus:border-[#e67e22] bg-white
              transition-all duration-300 hover:border-[#f39c12]`}
                        placeholder={languageData?.placeholder}
                      />
                      {touched.preferred_location &&
                        errors.preferred_location && (
                          <p className="text-red-500 text-sm">
                            {errors.preferred_location}
                          </p>
                        )}
                    </div>
                  </div>

                  <Popup
                    open={showConfirmationPopup}
                    onClose={() => setShowConfirmationPopup(false)}
                    modal
                    closeOnDocumentClick={false}
                  >
                    <div className="bg-white p-6 sm:p-8 rounded-2xl shadow-2xl max-w-md w-full border border-gray-200">
                      <h3 className="text-2xl font-extrabold text-[#d35400] mb-4 text-center">
                        {language === "english"
                          ? "Registration Confirmation"
                          : "பதிவு உறுதிப்படுத்தல்"}
                      </h3>

                      <div className="mb-4 text-center">
                        <p className="font-medium text-gray-700">
                          {language === "english"
                            ? "Your Matrimony ID:"
                            : "உங்கள் திருமண ஐடி:"}
                        </p>
                        <p className="text-3xl font-extrabold text-[#e67e22] tracking-wide mt-1">
                          {formData.matrimony_id}
                        </p>
                      </div>

                      <div className="mb-6">
                        <p className="font-semibold text-gray-800 mb-3">
                          {language === "english"
                            ? "Important Notes:"
                            : "முக்கியமான குறிப்புகள்:"}
                        </p>
                        <ul className="list-disc pl-5 space-y-2 text-gray-600 text-sm leading-relaxed">
                          <li>
                            {language === "english"
                              ? "Please remember your Matrimony ID for Login"
                              : "எதிர்கால குறிப்புக்காக உங்கள் திருமண ஐடியை நினைவில் கொள்ளவும்"}
                          </li>
                          <li>
                            {language === "english"
                              ? "Your profile will be verified by our team within 24 hours"
                              : "உங்கள் சுயவிவரம் 24 மணி நேரத்திற்குள் எங்கள் குழுவால் சரிபார்க்கப்படும்"}
                          </li>
                          <li>
                            {language === "english"
                              ? "You can login using your matrimonyid and password"
                              : "உங்கள் திருமண ஐடி எண் மற்றும் கடவுச்சொல்லைப் பயன்படுத்தி நீங்கள் உள்நுழையலாம்"}
                          </li>
                          <li>
                            {language === "english"
                              ? "Keep your contact details updated for better matches"
                              : "சிறந்த பொருத்தங்களுக்கு உங்கள் தொடர்பு விவரங்களை புதுப்பித்து வைக்கவும்"}
                          </li>
                        </ul>
                      </div>

                      <div className="flex justify-end gap-3 mt-6">
                        <button
                          onClick={() => setShowConfirmationPopup(false)}
                          className="px-4 py-2 text-sm font-semibold border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition"
                        >
                          {language === "english" ? "Cancel" : "ரத்து செய்"}
                        </button>
                        <button
                          onClick={handleConfirmedSubmit}
                          className="px-5 py-2 text-sm font-semibold bg-[#e67e22] text-white rounded-lg hover:bg-[#d35400] transition shadow-md"
                        >
                          {language === "english"
                            ? "Confirm Registration"
                            : "பதிவை உறுதிப்படுத்தவும்"}
                        </button>
                      </div>
                    </div>
                  </Popup>

                  <div className="flex items-center justify-end gap-2 mt-4 sm:mt-0 pb-3 ">
                    <button
                      type="button"
                      onClick={handlePreviousStep}
                      className="border-2 border-[#575757] text-[#676666] px-6 py-1.5 rounded-2xl font-medium transition-all duration-300 active:scale-95"
                    >
                      {languageData?.previous}
                    </button>
                    <button
                      type="submit"
                      className="rounded-2xl bg-[#fa6938]  text-white font-medium px-4 py-2 md:px-6 md:py-2 shadow-lg hover:shadow-xl transition-all duration-300 hover:from-[#d35400] hover:to-[#e67e22] active:scale-95 text-sm md:text-base"
                    >
                      {languageData?.registerNow}
                    </button>
                  </div>
                </form>
              )}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default RegisterForm;
